import _createClass from "@babel/runtime/helpers/esm/createClass";
import * as ColorFunctions from "../../../lib/styles/ColorFunctions";
import { exposeGetters } from "../../../lib/theming/ThemeHelpers";
export var DefaultTheme = /*#__PURE__*/function () {
  function DefaultTheme() {}

  _createClass(DefaultTheme, null, [{
    key: "bgSecondary",
    get: //#region Common variables
    // deprecated
    function get() {
      return this.bgDefault;
    }
  }, {
    key: "borderColorDisabled",
    get: function get() {
      return this.bgDisabled;
    }
  }, {
    key: "bgActive",
    get: function get() {
      return this.blueLight;
    }
  }, {
    key: "borderColorFocus",
    get: function get() {
      return this.blueLight;
    }
  }, {
    key: "borderColorError",
    get: function get() {
      return this.errorMain;
    }
  }, {
    key: "borderColorWarning",
    get: function get() {
      return this.warningMain;
    }
  }, {
    key: "linkHoverColor",
    get: function get() {
      return this.linkColor;
    }
  }, {
    key: "linkDisabledColor",
    get: function get() {
      return this.textColorDisabled;
    }
  }, {
    key: "linkGrayedColor",
    get: function get() {
      return this.textColorDisabled;
    }
  }, {
    key: "linkGrayedHoverColor",
    get: function get() {
      return this.textColorDisabled;
    }
  }, {
    key: "linkGrayedActiveColor",
    get: function get() {
      return this.textColorDisabled;
    }
  }, {
    key: "linkLineHoverBorderBottomStyle",
    get: function get() {
      return this.linkLineBorderBottomStyle;
    }
  }, {
    key: "tokenTextColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
    /**
     * @deprecated use tokenFontSizeSmall
     */

  }, {
    key: "tokenFontSize",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "tokenFontSizeSmall",
    get: function get() {
      return this.tokenFontSize;
    }
  }, {
    key: "tokenFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "tokenFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
    /**
     * @deprecated use tokenMarginYSmall
     */

  }, {
    key: "tokenMarginYSmall",
    get: function get() {
      return this.tokenMarginY;
    }
  }, {
    key: "tokenMarginXSmall",
    get: function get() {
      return this.tokenMarginX;
    }
  }, {
    key: "tokenLineHeight",
    get:
    /**
     * @deprecated use tokenLineHeightSmall
     */
    function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "tokenLineHeightSmall",
    get: function get() {
      return this.tokenLineHeight;
    }
  }, {
    key: "tokenLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "tokenLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
    /**
     * @deprecated use tokenPaddingYSmall
     */

  }, {
    key: "tokenPaddingYSmall",
    get: function get() {
      return this.tokenPaddingY;
    }
  }, {
    key: "tokenPaddingXSmall",
    get: function get() {
      return this.tokenPaddingX;
    }
  }, {
    key: "tokenDefaultIdle",
    get: function get() {
      return this.grayXLight;
    }
  }, {
    key: "tokenDefaultActive",
    get: function get() {
      return this.brand;
    }
  }, {
    key: "tokenGrayIdle",
    get: function get() {
      return this.grayXLight;
    }
  }, {
    key: "tokenGrayActive",
    get: function get() {
      return this.grayDark;
    }
  }, {
    key: "tokenBlueIdle",
    get: function get() {
      return this.blueLight;
    }
  }, {
    key: "tokenBlueActive",
    get: function get() {
      return this.blueDark;
    }
  }, {
    key: "tokenGreenIdle",
    get: function get() {
      return this.greenXxLight;
    }
  }, {
    key: "tokenGreenActive",
    get: function get() {
      return this.greenDark;
    }
  }, {
    key: "tokenYellowIdle",
    get: function get() {
      return this.yellowXxLight;
    }
  }, {
    key: "tokenYellowActive",
    get: function get() {
      return this.yellowDark;
    }
  }, {
    key: "tokenRedIdle",
    get: function get() {
      return this.redXxLight;
    }
  }, {
    key: "tokenRedActive",
    get: function get() {
      return this.redDark;
    }
  }, {
    key: "tokenWhite",
    get: function get() {
      return this.white;
    }
  }, {
    key: "tokenBlack",
    get: function get() {
      return this.black;
    }
  }, {
    key: "tokenBorderColorWarning",
    get: function get() {
      return this.borderColorWarning;
    }
  }, {
    key: "tokenBorderColorError",
    get: function get() {
      return this.borderColorError;
    }
  }, {
    key: "tokenPaddingYDisabled",
    get: function get() {
      return this.tokenPaddingY;
    }
  }, {
    key: "tokenPaddingXDisabled",
    get: function get() {
      return this.tokenPaddingX;
    }
  }, {
    key: "tokenMarginYDisabled",
    get: function get() {
      return this.tokenMarginY;
    }
  }, {
    key: "tokenMarginXDisabled",
    get: function get() {
      return this.tokenMarginX;
    }
  }, {
    key: "tokenShadowDisabled",
    get: function get() {
      return "0 0 0 " + this.tokenBorderWidth + " " + this.borderColorDisabled;
    }
  }, {
    key: "tokenInputLineHeight",
    get: //#endregion
    //#region TokenInput

    /**
     * @deprecated use tokenInputLineHeightSmall
     */
    function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "tokenInputLineHeightSmall",
    get: function get() {
      return this.tokenInputLineHeight;
    }
  }, {
    key: "tokenInputLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "tokenInputLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "tokenInputBorderColor",
    get: function get() {
      return this.inputBorderColor;
    }
  }, {
    key: "tokenInputBorderColorHover",
    get: function get() {
      return this.inputBorderColorHover;
    }
  }, {
    key: "tokenInputBorderColorFocus",
    get: function get() {
      return this.inputBorderColorFocus;
    }
  }, {
    key: "tokenInputBorderColorError",
    get: function get() {
      return this.inputBorderColorError;
    }
  }, {
    key: "tokenInputBorderColorWarning",
    get: function get() {
      return this.inputBorderColorWarning;
    }
  }, {
    key: "tokenInputBorderTopColor",
    get: function get() {
      return this.inputBorderTopColor;
    }
  }, {
    key: "tokenInputPlaceholderColor",
    get: function get() {
      return this.inputPlaceholderColor;
    }
  }, {
    key: "tokenInputPlaceholderColorLight",
    get: function get() {
      return this.inputPlaceholderColorLight;
    }
  }, {
    key: "tokenInputDisabledBg",
    get: function get() {
      return this.inputDisabledBg;
    }
  }, {
    key: "tokenInputDisabledBorderColor",
    get: function get() {
      return this.inputDisabledBorderColor;
    }
  }, {
    key: "tokenInputBorderWidth",
    get: function get() {
      return this.inputBorderWidth;
    }
  }, {
    key: "tokenInputOutlineWidth",
    get: function get() {
      return this.inputOutlineWidth;
    }
  }, {
    key: "tokenInputBg",
    get: function get() {
      return this.inputBg;
    }
  }, {
    key: "tokenInputMenuPopupBg",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "tokenInputShadow",
    get: function get() {
      return this.inputShadow;
    }
  }, {
    key: "tokenInputTextColor",
    get: function get() {
      return this.inputTextColor;
    }
  }, {
    key: "tokenInputTextColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
  }, {
    key: "tokenInputPlaceholderColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
    /**
     * @deprecated use tokenInputPaddingYSmall
     */

  }, {
    key: "tokenInputPaddingYSmall",
    get: function get() {
      return this.tokenInputPaddingY;
    }
  }, {
    key: "tokenInputPaddingXSmall",
    get: function get() {
      return this.tokenInputPaddingX;
    }
  }, {
    key: "btnCheckedDisabledBorderColor",
    get: function get() {
      return this.btnCheckedDisabledBg;
    }
  }, {
    key: "btnBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "btnOutlineWidth",
    get: function get() {
      return this.controlOutlineWidth;
    }
  }, {
    key: "btnIconGapSmallLeft",
    get: function get() {
      return this.btnIconGapSmall;
    }
  }, {
    key: "btnIconGapMediumLeft",
    get: function get() {
      return this.btnIconGapMedium;
    }
  }, {
    key: "btnIconGapLargeLeft",
    get: function get() {
      return this.btnIconGapLarge;
    }
  }, {
    key: "btnDefaultCheckedBorderColor",
    get: function get() {
      return this.btnCheckedBg;
    }
  }, {
    key: "btnDefaultTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "btnPayTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "btnFontSizeSmall",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "btnFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "btnFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
  }, {
    key: "btnLineHeightSmall",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "btnLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "btnLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "btnPaddingYSmall",
    get: function get() {
      return this.controlPaddingYSmall;
    }
  }, {
    key: "btnPaddingYMedium",
    get: function get() {
      return this.controlPaddingYMedium;
    }
  }, {
    key: "btnPaddingYLarge",
    get: function get() {
      return this.controlPaddingYLarge;
    }
  }, {
    key: "btnDisabledBg",
    get: function get() {
      return this.bgDisabled;
    }
  }, {
    key: "btnBorderColorWarning",
    get: function get() {
      return this.borderColorWarning;
    }
  }, {
    key: "btnBorderColorError",
    get: function get() {
      return this.borderColorError;
    }
  }, {
    key: "btnHeightSmall",
    get: function get() {
      var borderWidth = parseInt(this.btnBorderWidth, 10) || 0;
      var padding = parseInt(this.btnPaddingYSmall, 10) || 0;
      var lineHeigh = parseInt(this.btnLineHeightSmall, 10) || 0;
      return 2 * borderWidth + 2 * padding + lineHeigh + "px";
    }
  }, {
    key: "btnHeightMedium",
    get: function get() {
      var borderWidth = parseInt(this.btnBorderWidth, 10) || 0;
      var padding = parseInt(this.btnPaddingYMedium, 10) || 0;
      var lineHeigh = parseInt(this.btnLineHeightMedium, 10) || 0;
      return 2 * borderWidth + 2 * padding + lineHeigh + "px";
    }
  }, {
    key: "btnHeightLarge",
    get: function get() {
      var borderWidth = parseInt(this.btnBorderWidth, 10) || 0;
      var padding = parseInt(this.btnPaddingYLarge, 10) || 0;
      var lineHeigh = parseInt(this.btnLineHeightLarge, 10) || 0;
      return 2 * borderWidth + 2 * padding + lineHeigh + "px";
    }
  }, {
    key: "btnLinkColor",
    get: function get() {
      return this.linkColor;
    }
  }, {
    key: "btnLinkHoverColor",
    get: function get() {
      return this.linkHoverColor;
    }
  }, {
    key: "btnLinkActiveColor",
    get: function get() {
      return this.linkActiveColor;
    }
  }, {
    key: "btnLinkHoverTextDecoration",
    get: function get() {
      return this.linkHoverTextDecoration;
    }
  }, {
    key: "btnLinkLineBorderBottomColor",
    get: function get() {
      return this.linkLineBorderBottomColor;
    }
  }, {
    key: "btnLinkHoverLineBorderBottomStyle",
    get: function get() {
      return this.btnLinkLineBorderBottomStyle;
    }
  }, {
    key: "btnLinkLineBorderBottomOpacity",
    get: function get() {
      return this.linkLineBorderBottomOpacity;
    }
  }, {
    key: "btnLinkIconMarginRight",
    get: function get() {
      return this.linkIconMarginRight;
    }
  }, {
    key: "btnLinkIconMarginLeft",
    get: function get() {
      return this.linkIconMarginRight;
    }
  }, {
    key: "btnErrorSecondary",
    get: function get() {
      return this.errorSecondary;
    }
  }, {
    key: "btnWarningSecondary",
    get: function get() {
      return this.warningSecondary;
    }
  }, {
    key: "btnOutlineColorFocus",
    get: function get() {
      return this.outlineColorFocus;
    }
  }, {
    key: "btnBorderColorFocus",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "btnLinkDisabledColor",
    get: function get() {
      return this.linkDisabledColor;
    }
  }, {
    key: "btnDisabledTextColor",
    get: function get() {
      return this.textColorDisabledContrast;
    }
  }, {
    key: "btnBacklessBorderColor",
    get: function get() {
      return this.btnDefaultBorderColor;
    }
  }, {
    key: "btnBacklessDisabledBorderColor",
    get: function get() {
      return this.btnDisabledBorderColor;
    }
  }, {
    key: "btnBacklessHoverBorderColor",
    get: function get() {
      return this.btnBacklessBorderColor;
    }
  }, {
    key: "btnBacklessTextColor",
    get: function get() {
      return this.btnDefaultTextColor;
    }
  }, {
    key: "btnTextBorderColor",
    get: function get() {
      return this.btnDefaultBorderColor;
    }
  }, {
    key: "btnTextTextColor",
    get: function get() {
      return this.btnDefaultTextColor;
    }
  }, {
    key: "btnTextHoverBorderColor",
    get: function get() {
      return this.btnTextHoverBg;
    }
  }, {
    key: "selectDefaultBg",
    get: //#endregion
    //#region Select
    function get() {
      return this.inputBg;
    }
  }, {
    key: "selectBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "selectPlaceholderColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
  }, {
    key: "selectOutlineWidth",
    get: function get() {
      return this.controlOutlineWidth;
    }
  }, {
    key: "selectLineHeightSmall",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "selectFontSizeSmall",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "selectPaddingYSmall",
    get: function get() {
      return this.controlPaddingYSmall;
    }
  }, {
    key: "selectBorderRadiusSmall",
    get: function get() {
      return this.btnBorderRadiusSmall;
    }
  }, {
    key: "selectLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "selectFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "selectPaddingYMedium",
    get: function get() {
      return this.controlPaddingYMedium;
    }
  }, {
    key: "selectBorderRadiusMedium",
    get: function get() {
      return this.btnBorderRadiusMedium;
    }
  }, {
    key: "selectLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "selectFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
  }, {
    key: "selectPaddingYLarge",
    get: function get() {
      return this.controlPaddingYLarge;
    }
  }, {
    key: "selectBorderRadiusLarge",
    get: function get() {
      return this.btnBorderRadiusLarge;
    }
  }, {
    key: "selectMenuArrowColor",
    get: function get() {
      return this.btnMenuArrowColor;
    }
  }, {
    key: "selectMenuArrowColorDisabled",
    get: function get() {
      return this.selectMenuArrowColor;
    }
  }, {
    key: "selectIconSizeSmall",
    get: function get() {
      return this.btnIconSizeSmall;
    }
  }, {
    key: "selectIconSizeMedium",
    get: function get() {
      return this.btnIconSizeMedium;
    }
  }, {
    key: "selectIconSizeLarge",
    get: function get() {
      return this.btnIconSizeLarge;
    }
  }, {
    key: "selectTextColorDisabled",
    get: function get() {
      return this.btnDisabledTextColor;
    }
  }, {
    key: "selectBgDisabled",
    get: function get() {
      return this.btnDisabledBg;
    }
  }, {
    key: "selectBorderColorDisabled",
    get: function get() {
      return this.btnDisabledBorderColor;
    }
  }, {
    key: "selectMenuOffsetY",
    get: function get() {
      return this.menuOffsetY;
    }
  }, {
    key: "selectBorderColorHover",
    get: function get() {
      return this.btnDefaultHoverBorderColor;
    }
  }, {
    key: "tooltipTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "tooltipBorder",
    get: function get() {
      return this.popupBorder;
    }
  }, {
    key: "tooltipBorderRadius",
    get: function get() {
      return this.popupBorderRadius;
    }
  }, {
    key: "tooltipPinSize",
    get: function get() {
      return this.popupPinSize;
    }
  }, {
    key: "tooltipFontSize",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "tooltipLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    } //#endregion
    //#region TooltipMenu

  }, {
    key: "tooltipMenuPinOffset",
    get: function get() {
      return this.popupPinOffset;
    }
  }, {
    key: "tooltipMenuMargin",
    get: function get() {
      return this.popupMargin;
    }
  }, {
    key: "tooltipMenuPinSize",
    get: function get() {
      return this.popupPinSize;
    } //#endregion
    //#region Kebab

  }, {
    key: "kebabPinOffset",
    get: function get() {
      return this.popupPinOffset;
    }
  }, {
    key: "kebabPinSize",
    get: function get() {
      return this.popupPinSize;
    }
  }, {
    key: "kebabBackgroundActive",
    get: function get() {
      return this.kebabBackgroundHover;
    }
  }, {
    key: "modalBg",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "modalFixedHeaderBg",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "modalFixedHeaderShadow",
    get: function get() {
      return this.fixedPanelShadow;
    }
  }, {
    key: "modalFixedFooterShadow",
    get: function get() {
      return this.fixedPanelShadow;
    }
  }, {
    key: "modalHeaderTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "modalFixedHeaderPaddingBottom",
    get: function get() {
      return Math.round(parseInt(this.modalHeaderPaddingBottom) / 2) + "px";
    }
  }, {
    key: "sidePageBgDefault",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "sidePageHeaderTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "sidePageFixedHeaderShadow",
    get: function get() {
      return this.fixedPanelShadow;
    }
  }, {
    key: "sidePageFixedFooterShadow",
    get: function get() {
      return this.fixedPanelShadow;
    }
  }, {
    key: "dateInputIconColor",
    get: //#endregion
    //#region DateInput
    function get() {
      return this.textColorDefault;
    }
  }, {
    key: "dateInputComponentSelectedTextColor",
    get: function get() {
      return this.textColorDefault;
    } //#endregion
    //#region Calendar

  }, {
    key: "calendarBottomSeparatorBorderColor",
    get: function get() {
      return ColorFunctions.fade(this.calendarMonthTitleBorderBottomColor, 1);
    }
  }, {
    key: "calendarBottomSeparatorBorderWidth",
    get: function get() {
      return '1px';
    }
  }, {
    key: "calendarBottomSeparatorBorder",
    get: function get() {
      return this.calendarBottomSeparatorBorderWidth + " solid " + this.calendarBottomSeparatorBorderColor;
    }
  }, {
    key: "calendarBg",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "calendarCellBg",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "calendarCellHeight",
    get: // deprecated
    function get() {
      return this.calendarCellSize;
    }
  }, {
    key: "calendarCellWidth",
    get: function get() {
      return this.calendarCellSize;
    }
  }, {
    key: "calendarCellLineHeight",
    get: function get() {
      return parseInt(this.calendarCellHeight) - 2 + "px";
    }
  }, {
    key: "calendarMonthHeaderStickedBgColor",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "calendarCellHoverBgColor",
    get: function get() {
      return this.bgActive;
    }
  }, {
    key: "dateSelectTextColorDisabled",
    get: function get() {
      return this.textColorDisabled;
    }
  }, {
    key: "dateSelectTextColorDefault",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "dateSelectLinkColor",
    get: function get() {
      return this.linkColor;
    }
  }, {
    key: "dateSelectPopupBoxShadow",
    get: function get() {
      return this.popupBoxShadow;
    }
  }, {
    key: "dateSelectTextColorInvert",
    get: function get() {
      return this.textColorInvert;
    }
  }, {
    key: "datePickerOpenBtnColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "pickerBg",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "pickerTodayWrapperBgColor",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "dateSelectMenuBg",
    get: //#endregion
    //#region DateSelect
    function get() {
      return this.bgSecondary;
    }
  }, {
    key: "dateSelectMenuItemBgActive",
    get: function get() {
      return this.bgActive;
    }
  }, {
    key: "dateSelectMenuItemBgDisabled",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "dateSelectMenuItemFontActive",
    get: function get() {
      return this.textColorInvert;
    }
  }, {
    key: "dateSelectMenuItemFontSelected",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "dateSelectMenuItemFontDisabled",
    get: function get() {
      return this.textColorDisabled;
    } //#endregion
    //#region Paging

  }, {
    key: "pagingFontSize",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "pagingForwardIconSize",
    get: function get() {
      return this.pagingFontSize;
    }
  }, {
    key: "pagingPageLinkActiveColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "pagingPageLinkHintColor",
    get: function get() {
      return this.placeholderColor;
    }
  }, {
    key: "pagingForwardLinkColor",
    get: function get() {
      return this.linkColor;
    }
  }, {
    key: "pagingForwardLinkDisabledColor",
    get: function get() {
      return this.linkDisabledColor;
    }
  }, {
    key: "pagingDotsDisabledColor",
    get: function get() {
      return this.textColorDisabled;
    } //#endregion
    //#region Hint

  }, {
    key: "hintColor",
    get: function get() {
      return this.textColorInvert;
    }
  }, {
    key: "mobileHintColor",
    get: function get() {
      return this.hintColor;
    }
  }, {
    key: "hintFontSize",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "hintLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "toastFontSize",
    get: //#endregion
    //#region Toast
    function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "toastLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "dropdownMenuHoverBorderColor",
    get: function get() {
      return this.btnDefaultHoverBorderColor;
    }
  }, {
    key: "dropdownMenuHoverBg",
    get: function get() {
      //deprecated
      return this.bgActive;
    }
  }, {
    key: "dropdownMenuOffsetY",
    get: function get() {
      return this.menuOffsetY;
    }
  }, {
    key: "dropdownMenuMenuOffsetY",
    get: function get() {
      return this.menuOffsetY;
    }
  }, {
    key: "dropdownDefaultBg",
    get: function get() {
      return this.btnDefaultBg;
    }
  }, {
    key: "dropdownBorderWidth",
    get: function get() {
      return this.btnBorderWidth;
    }
  }, {
    key: "dropdownOutlineWidth",
    get: function get() {
      return this.btnOutlineWidth;
    }
  }, {
    key: "dropdownLineHeightSmall",
    get: function get() {
      return this.btnLineHeightSmall;
    }
  }, {
    key: "dropdownFontSizeSmall",
    get: function get() {
      return this.btnFontSizeSmall;
    }
  }, {
    key: "dropdownPaddingXSmall",
    get: function get() {
      return this.selectPaddingXSmall;
    }
  }, {
    key: "dropdownPaddingYSmall",
    get: function get() {
      return this.btnPaddingYSmall;
    }
  }, {
    key: "dropdownIconSizeSmall",
    get: function get() {
      return this.btnIconSizeSmall;
    }
  }, {
    key: "dropdownLineHeightMedium",
    get: function get() {
      return this.btnLineHeightMedium;
    }
  }, {
    key: "dropdownFontSizeMedium",
    get: function get() {
      return this.btnFontSizeMedium;
    }
  }, {
    key: "dropdownPaddingXMedium",
    get: function get() {
      return this.selectPaddingXMedium;
    }
  }, {
    key: "dropdownPaddingYMedium",
    get: function get() {
      return this.btnPaddingYMedium;
    }
  }, {
    key: "dropdownIconSizeMedium",
    get: function get() {
      return this.btnIconSizeMedium;
    }
  }, {
    key: "dropdownLineHeightLarge",
    get: function get() {
      return this.btnLineHeightLarge;
    }
  }, {
    key: "dropdownFontSizeLarge",
    get: function get() {
      return this.btnFontSizeLarge;
    }
  }, {
    key: "dropdownPaddingXLarge",
    get: function get() {
      return this.selectPaddingXLarge;
    }
  }, {
    key: "dropdownPaddingYLarge",
    get: function get() {
      return this.btnPaddingYLarge;
    }
  }, {
    key: "dropdownIconSizeLarge",
    get: function get() {
      return this.btnIconSizeLarge;
    }
  }, {
    key: "dropdownBgDisabled",
    get: function get() {
      return this.btnDisabledBg;
    }
  }, {
    key: "dropdownBorderColorDisabled",
    get: function get() {
      return this.btnDisabledBorderColor;
    }
  }, {
    key: "dropdownTextColorDisabled",
    get: function get() {
      return this.btnDisabledTextColor;
    } //#endregion
    //#region Menu

  }, {
    key: "menuBgDefault",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "menuBorderRadius",
    get: function get() {
      return '0px';
    }
  }, {
    key: "menuItemTextColor",
    get: // menuItem
    function get() {
      return this.textColorDefault;
    }
  }, {
    key: "menuItemSelectedBg",
    get: function get() {
      return this.dropdownMenuSelectedBg;
    }
  }, {
    key: "menuItemHoverBg",
    get: function get() {
      return this.dropdownMenuHoverBg;
    }
    /**
     * @deprecated use menuItemIconWidthSmall
     */

  }, {
    key: "menuItemIconWidthSmall",
    get: function get() {
      return this.menuItemIconWidth;
    }
  }, {
    key: "menuItemPaddingForIcon",
    get:
    /**
     * @deprecated use menuItemPaddingForIconSmall
     */
    function get() {
      return parseInt(this.menuItemPaddingXSmall) + parseInt(this.menuItemIconWidthSmall) + parseInt(this.menuItemIconGap) + parseInt(this.menuItemIconLegacyMargin) + "px";
    }
  }, {
    key: "menuItemPaddingForIconSmall",
    get: function get() {
      return this.menuItemPaddingForIcon;
    }
  }, {
    key: "menuItemPaddingForIconMedium",
    get: function get() {
      return parseInt(this.menuItemPaddingXMedium) + parseInt(this.menuItemIconWidthMedium) + parseInt(this.menuItemIconGap) + parseInt(this.menuItemIconLegacyMargin) + "px";
    }
  }, {
    key: "menuItemPaddingForIconLarge",
    get: function get() {
      return parseInt(this.menuItemPaddingXLarge) + parseInt(this.menuItemIconWidthLarge) + parseInt(this.menuItemIconGap) + parseInt(this.menuItemIconLegacyMargin) + "px";
    }
    /**
     * @deprecated use menuItemLineHeightSmall
     */

  }, {
    key: "menuItemLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "menuItemLineHeightSmall",
    get: function get() {
      return this.menuItemLineHeight;
    }
  }, {
    key: "menuItemLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "menuItemLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
    /**
     * @deprecated use menuItemFontSizeSmall
     */

  }, {
    key: "menuItemFontSize",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "menuItemFontSizeSmall",
    get: function get() {
      return this.menuItemFontSize;
    }
  }, {
    key: "menuItemFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "menuItemFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
    /**
     * @deprecated use menuItemPaddingXSmall
     */

  }, {
    key: "menuItemPaddingXSmall",
    get: function get() {
      return this.menuItemPaddingX;
    }
  }, {
    key: "menuItemPaddingYSmall",
    get: function get() {
      return this.menuItemPaddingY;
    }
  }, {
    key: "menuItemHoverColor",
    get: function get() {
      return this.textColorInvert;
    }
  }, {
    key: "menuItemLinkColor",
    get: function get() {
      return this.linkColor;
    }
  }, {
    key: "menuItemLineHeightMobile",
    get: function get() {
      return this.lineHeightMobile;
    }
  }, {
    key: "menuItemFontSizeMobile",
    get: function get() {
      return this.fontSizeMobile;
    }
  }, {
    key: "menuItemDisabledColor",
    get: function get() {
      return this.textColorDisabled;
    }
  }, {
    key: "menuMessageTextColor",
    get: // menuMessage
    function get() {
      return this.menuItemDisabledColor;
    }
  }, {
    key: "menuMessageBg",
    get: function get() {
      return this.menuItemDisabledBg;
    }
  }, {
    key: "menuMessagePaddingY",
    get: function get() {
      return this.menuItemPaddingYSmall;
    }
  }, {
    key: "menuMessagePaddingX",
    get: function get() {
      return this.menuItemPaddingXSmall;
    }
  }, {
    key: "menuMessageDisplay",
    get: function get() {
      return this.menuItemDisplay;
    }
  }, {
    key: "menuMessagePaddingMobile",
    get: function get() {
      return this.menuItemPaddingMobile;
    }
    /**
     * @deprecated use menuMessageLineHeightSmall
     */

  }, {
    key: "menuMessageLineHeight",
    get: function get() {
      return this.menuItemLineHeightSmall;
    }
  }, {
    key: "menuMessageLineHeightMobile",
    get: function get() {
      return this.menuItemLineHeightMobile;
    }
    /**
     * @deprecated use menuMessageFontSizeSmall
     */

  }, {
    key: "menuMessageFontSize",
    get: function get() {
      return this.menuItemFontSizeSmall;
    }
  }, {
    key: "menuMessageFontSizeMobile",
    get: function get() {
      return this.menuItemFontSizeMobile;
    }
  }, {
    key: "menuMessageFontSizeSmall",
    get: function get() {
      return this.menuItemFontSizeSmall;
    }
  }, {
    key: "menuMessageFontSizeMedium",
    get: function get() {
      return this.menuItemFontSizeMedium;
    }
  }, {
    key: "menuMessageFontSizeLarge",
    get: function get() {
      return this.menuItemFontSizeLarge;
    }
  }, {
    key: "menuMessageLineHeightSmall",
    get: function get() {
      return this.menuItemLineHeightSmall;
    }
  }, {
    key: "menuMessageLineHeightMedium",
    get: function get() {
      return this.menuItemLineHeightMedium;
    }
  }, {
    key: "menuMessageLineHeightLarge",
    get: function get() {
      return this.menuItemLineHeightLarge;
    }
  }, {
    key: "menuHeaderLineHeightSmall",
    get: function get() {
      return this.menuHeaderLineHeight;
    }
  }, {
    key: "menuHeaderFontSizeSmall",
    get: function get() {
      return this.menuHeaderFontSize;
    }
  }, {
    key: "menuHeaderPaddingXSmall",
    get: function get() {
      return this.menuHeaderPaddingX;
    }
  }, {
    key: "menuHeaderPaddingTopSmall",
    get: function get() {
      return this.menuHeaderPaddingTop;
    }
  }, {
    key: "menuHeaderPaddingBottomSmall",
    get: function get() {
      return this.menuHeaderPaddingBottom;
    }
  }, {
    key: "menuFooterColor",
    get: //menuFooter
    function get() {
      return this.menuHeaderColor;
    }
  }, {
    key: "menuFooterLineHeightSmall",
    get: function get() {
      return this.menuHeaderLineHeightSmall;
    }
  }, {
    key: "menuFooterLineHeightMedium",
    get: function get() {
      return this.menuHeaderLineHeightMedium;
    }
  }, {
    key: "menuFooterLineHeightLarge",
    get: function get() {
      return this.menuHeaderLineHeightLarge;
    }
  }, {
    key: "menuFooterFontSizeSmall",
    get: function get() {
      return this.menuHeaderFontSizeSmall;
    }
  }, {
    key: "menuFooterFontSizeMedium",
    get: function get() {
      return this.menuHeaderFontSizeMedium;
    }
  }, {
    key: "menuFooterFontSizeLarge",
    get: function get() {
      return this.menuHeaderFontSizeLarge;
    }
  }, {
    key: "menuFooterPaddingXSmall",
    get: function get() {
      return this.menuHeaderPaddingXSmall;
    }
  }, {
    key: "menuFooterPaddingXMedium",
    get: function get() {
      return this.menuHeaderPaddingXMedium;
    }
  }, {
    key: "menuFooterPaddingXLarge",
    get: function get() {
      return this.menuHeaderPaddingXLarge;
    }
  }, {
    key: "menuFooterPaddingTopSmall",
    get: function get() {
      return this.menuHeaderPaddingBottomSmall;
    }
  }, {
    key: "menuFooterPaddingTopMedium",
    get: function get() {
      return this.menuHeaderPaddingBottomMedium;
    }
  }, {
    key: "menuFooterPaddingTopLarge",
    get: function get() {
      return this.menuHeaderPaddingBottomLarge;
    }
  }, {
    key: "menuFooterPaddingBottomSmall",
    get: function get() {
      return this.menuHeaderPaddingTopSmall;
    }
  }, {
    key: "menuFooterPaddingBottomMedium",
    get: function get() {
      return this.menuHeaderPaddingTopMedium;
    }
  }, {
    key: "menuFooterPaddingBottomLarge",
    get: function get() {
      return this.menuHeaderPaddingTopLarge;
    }
  }, {
    key: "toggleFontSize",
    get: //#endregion
    //#region Toggle

    /**
     * @deprecated use toggleFontSizeSmall
     */
    function get() {
      return this.fontSizeSmall;
    }
    /**
     * @deprecated use toggleLineHeightSmall
     */

  }, {
    key: "toggleLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "toggleLineHeightSmall",
    get: function get() {
      return this.toggleLineHeight;
    }
  }, {
    key: "toggleLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "toggleLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "toggleFontSizeSmall",
    get: function get() {
      return this.toggleFontSize;
    }
  }, {
    key: "toggleFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "toggleFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
  }, {
    key: "toggleTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "toggleHandleBorderRadius",
    get:
    /**
     * @deprecated use toggleHandleBorderRadiusSmall
     */
    function get() {
      var height = parseInt(this.toggleHeightSmall, 10) || 0;
      var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
      var handleSize = height - 2 * borderWidth;
      return handleSize / 2 + "px";
    }
  }, {
    key: "toggleHandleBorderRadiusSmall",
    get: function get() {
      return this.toggleHandleBorderRadius;
    }
  }, {
    key: "toggleHandleBorderRadiusMedium",
    get: function get() {
      var height = parseInt(this.toggleHeightMedium, 10) || 0;
      var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
      var handleSize = height - 2 * borderWidth;
      return handleSize / 2 + "px";
    }
  }, {
    key: "toggleHandleBorderRadiusLarge",
    get: function get() {
      var height = parseInt(this.toggleHeightLarge, 10) || 0;
      var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
      var handleSize = height - 2 * borderWidth;
      return handleSize / 2 + "px";
    }
    /**
     * @deprecated use toggleHeightSmall
     */

  }, {
    key: "toggleHeightSmall",
    get: function get() {
      return this.toggleHeight;
    }
  }, {
    key: "toggleWidthSmall",
    get: function get() {
      return this.toggleWidth;
    }
  }, {
    key: "toggleBorderRadius",
    get:
    /**
     * @deprecated use toggleBorderRadiusSmall
     */
    function get() {
      return "calc(" + this.toggleHeightSmall + " * 0.5)";
    }
  }, {
    key: "toggleBorderRadiusSmall",
    get: function get() {
      return this.toggleBorderRadius;
    }
  }, {
    key: "toggleBorderRadiusMedium",
    get: function get() {
      return "calc(" + this.toggleHeightMedium + " * 0.5)";
    }
  }, {
    key: "toggleBorderRadiusLarge",
    get: function get() {
      return "calc(" + this.toggleHeightLarge + " * 0.5)";
    }
    /**
     * @deprecated use toggleHandleBg
     */

  }, {
    key: "toggleBgDisabled",
    get: function get() {
      return this.bgDisabled;
    }
  }, {
    key: "toggleBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "toggleOutlineWidth",
    get: function get() {
      var outlineWidth = parseInt(this.controlOutlineWidth, 10) || 0;
      var borderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
      return outlineWidth + borderWidth + "px";
    }
  }, {
    key: "toggleBorderColorDisabled",
    get: function get() {
      return this.toggleBorderColor;
    }
  }, {
    key: "toggleBorderColorDisabledChecked",
    get: function get() {
      return this.toggleBorderColor;
    }
    /**
     * @deprecated use toggleHandleSizeSmall
     */

  }, {
    key: "toggleHandleSize",
    get: function get() {
      var toggleHeight = parseInt(this.toggleHeightSmall, 10) || 0;
      var toggleBorderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
      return toggleHeight - 2 * toggleBorderWidth + "px";
    }
  }, {
    key: "toggleHandleSizeSmall",
    get: function get() {
      return this.toggleHandleSize;
    }
  }, {
    key: "toggleHandleSizeMedium",
    get: function get() {
      var toggleHeight = parseInt(this.toggleHeightMedium, 10) || 0;
      var toggleBorderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
      return toggleHeight - 2 * toggleBorderWidth + "px";
    }
  }, {
    key: "toggleHandleSizeLarge",
    get: function get() {
      var toggleHeight = parseInt(this.toggleHeightLarge, 10) || 0;
      var toggleBorderWidth = parseInt(this.toggleBorderWidth, 10) || 0;
      return toggleHeight - 2 * toggleBorderWidth + "px";
    }
  }, {
    key: "toggleHandleLeft",
    get: function get() {
      return this.toggleBorderWidth;
    }
  }, {
    key: "toggleHandleTop",
    get: function get() {
      return this.toggleBorderWidth;
    }
  }, {
    key: "toggleShadowColorError",
    get: function get() {
      return this.errorMain;
    }
  }, {
    key: "toggleShadowColorWarning",
    get: function get() {
      return this.warningMain;
    }
  }, {
    key: "toggleFocusShadowColor",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "toggleOutlineColorFocus",
    get: function get() {
      return this.outlineColorFocus;
    }
  }, {
    key: "toggleHandleBoxShadowOld",
    get: function get() {
      return "0 " + this.toggleBorderWidth + " 0 0 rgba(0, 0, 0, 0.15), 0 0 0 " + this.toggleBorderWidth + " rgba(0, 0, 0, 0.15)";
    }
  }, {
    key: "toggleContainerBgHover",
    get: function get() {
      return this.toggleBgHover;
    }
  }, {
    key: "toggleContainerBgChecked",
    get: function get() {
      return this.toggleBgChecked;
    }
  }, {
    key: "toggleHandleBg",
    get: function get() {
      return this.toggleBg;
    }
  }, {
    key: "popupTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "popupBackground",
    get: function get() {
      return this.bgSecondary;
    }
  }, {
    key: "inputTextColor",
    get: //#endregion
    //#region Input
    function get() {
      return this.textColorDefault;
    }
  }, {
    key: "inputIconColorDisabled",
    get: function get() {
      return this.inputIconColor;
    }
  }, {
    key: "inputFocusedIconColor",
    get: function get() {
      return this.inputIconColor;
    }
  }, {
    key: "inputTextColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
  }, {
    key: "inputFontSizeSmall",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "inputFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "inputFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
  }, {
    key: "inputLineHeightSmall",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "inputLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "inputLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "inputHeightSmall",
    get: function get() {
      var borderWidth = parseInt(this.inputBorderWidth, 10) || 0;
      var padding = parseInt(this.inputPaddingYSmall, 10) || 0;
      var lineHeigh = parseInt(this.inputLineHeightSmall, 10) || 0;
      return 2 * borderWidth + 2 * padding + lineHeigh + "px";
    }
  }, {
    key: "inputHeightMedium",
    get: function get() {
      var borderWidth = parseInt(this.inputBorderWidth, 10) || 0;
      var padding = parseInt(this.inputPaddingYMedium, 10) || 0;
      var lineHeigh = parseInt(this.inputLineHeightMedium, 10) || 0;
      return 2 * borderWidth + 2 * padding + lineHeigh + "px";
    }
  }, {
    key: "inputHeightLarge",
    get: function get() {
      var borderWidth = parseInt(this.inputBorderWidth, 10) || 0;
      var padding = parseInt(this.inputPaddingYLarge, 10) || 0;
      var lineHeigh = parseInt(this.inputLineHeightLarge, 10) || 0;
      return 2 * borderWidth + 2 * padding + lineHeigh + "px";
    }
  }, {
    key: "inputPaddingYSmall",
    get: function get() {
      return this.controlPaddingYSmall;
    }
  }, {
    key: "inputPaddingYMedium",
    get: function get() {
      return this.controlPaddingYMedium;
    }
  }, {
    key: "inputPaddingYLarge",
    get: function get() {
      return this.controlPaddingYLarge;
    }
  }, {
    key: "inputFocusShadow",
    get: function get() {
      return "0 0 0 " + this.inputOutlineWidth + " " + this.borderColorFocus;
    }
  }, {
    key: "inputFocusedBg",
    get: function get() {
      return this.inputBg;
    }
  }, {
    key: "inputDisabledBg",
    get: function get() {
      return this.bgDisabled;
    }
  }, {
    key: "inputDisabledBorderColor",
    get: function get() {
      return this.borderColorDisabled;
    }
  }, {
    key: "inputFocusOutline",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "inputBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "inputOutlineWidth",
    get: function get() {
      return "calc(" + this.controlOutlineWidth + " - 1px)";
    }
  }, {
    key: "inputBorderColor",
    get: function get() {
      return this.borderColorGrayLight;
    }
  }, {
    key: "inputBorderColorHover",
    get: function get() {
      return this.inputBorderColor;
    }
  }, {
    key: "inputBorderColorFocus",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "inputBorderColorError",
    get: function get() {
      return this.borderColorError;
    }
  }, {
    key: "inputBorderColorWarning",
    get: function get() {
      return this.borderColorWarning;
    }
  }, {
    key: "inputPlaceholderColor",
    get: function get() {
      return this.placeholderColor;
    }
  }, {
    key: "inputPlaceholderColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
  }, {
    key: "inputPlaceholderColorLight",
    get: function get() {
      return this.placeholderColorLight;
    }
  }, {
    key: "inputBlinkColor",
    get: function get() {
      return this.blinkColor;
    }
  }, {
    key: "checkboxFontSize",
    get: //#endregion
    //#region Checkbox

    /**
     * @deprecated use checkboxFontSizeSmall
     */
    function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "checkboxFontSizeSmall",
    get: function get() {
      return this.checkboxFontSize;
    }
  }, {
    key: "checkboxFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "checkboxFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
    /**
     * @deprecated use checkboxLineHeightSmall
     */

  }, {
    key: "checkboxLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "checkboxLineHeightSmall",
    get: function get() {
      return this.checkboxLineHeight;
    }
  }, {
    key: "checkboxLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "checkboxLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
    /**
     * @deprecated use checkboxBoxSizeSmall
     */

  }, {
    key: "checkboxPaddingY",
    get:
    /**
     * @deprecated use checkboxPaddingYSmall
     */
    function get() {
      var controlHeight = parseInt(this.controlHeightSmall, 10) || 0;
      var lineHeight = parseInt(this.checkboxLineHeightSmall, 10) || 0;
      return (controlHeight - lineHeight) / 2 + "px";
    }
  }, {
    key: "checkboxPaddingYSmall",
    get: function get() {
      return this.checkboxPaddingY;
    }
  }, {
    key: "checkboxPaddingYMedium",
    get: function get() {
      var controlHeight = parseInt(this.controlHeightMedium, 10) || 0;
      var lineHeight = parseInt(this.checkboxLineHeightMedium, 10) || 0;
      return (controlHeight - lineHeight) / 2 + "px";
    }
  }, {
    key: "checkboxPaddingYLarge",
    get: function get() {
      var controlHeight = parseInt(this.controlHeightLarge, 10) || 0;
      var lineHeight = parseInt(this.checkboxLineHeightLarge, 10) || 0;
      return (controlHeight - lineHeight) / 2 + "px";
    }
  }, {
    key: "checkboxTextColorDefault",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "checkboxTextColorDisabled",
    get: function get() {
      return this.textColorDisabled;
    }
  }, {
    key: "checkboxShadowDisabled",
    get: function get() {
      return "0 0 0 " + this.checkboxBorderWidth + " " + this.borderColorDisabled;
    }
  }, {
    key: "checkboxBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "checkboxShadow",
    get: function get() {
      return "0 0 0 " + this.checkboxBorderWidth + " rgba(0, 0, 0, 0.15)";
    }
  }, {
    key: "checkboxShadowHover",
    get: function get() {
      return "0 0 0 " + this.checkboxBorderWidth + " #c3c3c3";
    }
  }, {
    key: "checkboxOutlineColorFocus",
    get: function get() {
      return this.outlineColorFocus;
    }
  }, {
    key: "checkboxBorderColorWarning",
    get: function get() {
      return this.borderColorWarning;
    }
  }, {
    key: "checkboxBorderColorError",
    get: function get() {
      return this.borderColorError;
    }
  }, {
    key: "checkboxCheckedHoverShadow",
    get: function get() {
      return "0 0 0 " + this.checkboxBorderWidth + " " + this.checkboxCheckedHoverBg;
    }
  }, {
    key: "checkboxOutlineWidth",
    get: function get() {
      return this.controlOutlineWidth;
    }
  }, {
    key: "checkboxCheckedShadow",
    get: function get() {
      return "0 0 0 " + this.checkboxBorderWidth + " " + this.checkboxCheckedBg;
    }
  }, {
    key: "checkboxCheckedActiveShadow",
    get: function get() {
      return "0 0 0 " + this.checkboxBorderWidth + " " + this.checkboxCheckedActiveBg;
    }
  }, {
    key: "checkboxBorderColorFocus",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "checkboxHoverBg",
    get: function get() {
      return this.btnDefaultHoverBg;
    }
  }, {
    key: "checkboxActiveBg",
    get: function get() {
      return this.btnDefaultActiveBg;
    }
  }, {
    key: "checkboxCheckedBg",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "checkboxBgDisabled",
    get: function get() {
      return this.bgDisabled;
    }
  }, {
    key: "checkboxCheckedHoverBg",
    get: function get() {
      return ColorFunctions.darken(this.checkboxCheckedBg, '5%');
    }
  }, {
    key: "checkboxCheckedActiveBg",
    get: function get() {
      return ColorFunctions.darken(this.checkboxCheckedBg, '15%');
    }
  }, {
    key: "checkboxShadowActive",
    get: function get() {
      return "0 0 0 " + this.checkboxBorderWidth + " #c3c3c3";
    } //#endregion
    //#region TextArea

  }, {
    key: "textareaColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "textareaTextColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
  }, {
    key: "textareaPlaceholderColorLight",
    get: function get() {
      return this.placeholderColorLight;
    }
  }, {
    key: "textareaPlaceholderColor",
    get: function get() {
      return this.placeholderColor;
    }
  }, {
    key: "textareaPlaceholderColorDisabled",
    get: function get() {
      return this.textColorDisabledContrast;
    }
  }, {
    key: "textareaFontSize",
    get:
    /**
     * @deprecated use textareaFontSizeSmall
     */
    function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "textareaFontSizeSmall",
    get: function get() {
      return this.textareaFontSize;
    }
  }, {
    key: "textareaFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "textareaFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
    /**
     * @deprecated use textareaLineHeightSmall
     */

  }, {
    key: "textareaLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "textareaLineHeightSmall",
    get: function get() {
      return this.textareaLineHeight;
    }
  }, {
    key: "textareaLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "textareaLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "textareaBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "textareaOutlineWidth",
    get: function get() {
      var outlineWidth = parseInt(this.controlOutlineWidth, 10) || 0;
      var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
      return outlineWidth - borderWidth + "px";
    }
    /**
     * @deprecated use textareaMinHeightSmall
     */

  }, {
    key: "textareaMinHeight",
    get: function get() {
      var lineHeight = parseInt(this.textareaLineHeightSmall, 10) || 0;
      var paddingY = parseInt(this.textareaPaddingYSmall, 10) || 0;
      var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
      return lineHeight + paddingY * 2 + borderWidth * 2 + "px";
    }
  }, {
    key: "textareaMinHeightSmall",
    get: function get() {
      return this.textareaMinHeight;
    }
  }, {
    key: "textareaMinHeightMedium",
    get: function get() {
      var lineHeight = parseInt(this.textareaLineHeightMedium, 10) || 0;
      var paddingY = parseInt(this.textareaPaddingYMedium, 10) || 0;
      var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
      return lineHeight + paddingY * 2 + borderWidth * 2 + "px";
    }
  }, {
    key: "textareaMinHeightLarge",
    get: function get() {
      var lineHeight = parseInt(this.textareaLineHeightLarge, 10) || 0;
      var paddingY = parseInt(this.textareaPaddingYLarge, 10) || 0;
      var borderWidth = parseInt(this.textareaBorderWidth, 10) || 0;
      return lineHeight + paddingY * 2 + borderWidth * 2 + "px";
    }
  }, {
    key: "textareaPaddingXSmall",
    get: function get() {
      return this.textareaPaddingX;
    }
  }, {
    key: "textareaPaddingY",
    get:
    /**
     * @deprecated use textareaPaddingYSmall
     */
    function get() {
      return this.controlPaddingYSmall;
    }
  }, {
    key: "textareaPaddingYSmall",
    get: function get() {
      return this.textareaPaddingY;
    }
  }, {
    key: "textareaPaddingYMedium",
    get: function get() {
      return this.controlPaddingYMedium;
    }
  }, {
    key: "textareaPaddingYLarge",
    get: function get() {
      return this.controlPaddingYLarge;
    }
  }, {
    key: "textareaBorderColor",
    get: function get() {
      return this.borderColorGrayLight;
    }
  }, {
    key: "textareaBorderColorFocus",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "textareaBorderColorHover",
    get: function get() {
      return this.inputBorderColorHover;
    }
  }, {
    key: "textareaBorderColorWarning",
    get: function get() {
      return this.borderColorWarning;
    }
  }, {
    key: "textareaBorderColorError",
    get: function get() {
      return this.borderColorError;
    }
  }, {
    key: "textareaCounterColor",
    get: function get() {
      return this.gray;
    }
  }, {
    key: "textareaCounterBg",
    get: function get() {
      return ColorFunctions.fade(this.textareaBg, 0.9);
    }
  }, {
    key: "textareaCounterErrorColor",
    get: function get() {
      return this.errorText;
    }
  }, {
    key: "textareaCounterHelpIconColor",
    get: function get() {
      return this.linkColor;
    } //#endregion
    //#region Radio

    /**
     * @deprecated use radioBulletSizeSmall
     */

  }, {
    key: "radioBulletSizeSmall",
    get: function get() {
      return this.radioBulletSize;
    }
  }, {
    key: "radioOutlineWidth",
    get: function get() {
      return this.controlOutlineWidth;
    }
  }, {
    key: "radioTextColor",
    get: function get() {
      return this.textColorDefault;
    }
    /**
     * @deprecated use radioSizeSmall
     */

  }, {
    key: "radioSizeSmall",
    get: function get() {
      return this.radioSize;
    }
  }, {
    key: "radioFontSize",
    get:
    /**
     * @deprecated use radioFontSizeSmall
     */
    function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "radioFontSizeSmall",
    get: function get() {
      return this.radioFontSize;
    }
  }, {
    key: "radioFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "radioFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
    /**
     * @deprecated use radioLineHeightSmall
     */

  }, {
    key: "radioLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "radioLineHeightSmall",
    get: function get() {
      return this.radioLineHeight;
    }
  }, {
    key: "radioLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "radioLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "radioPaddingY",
    get:
    /**
     * @deprecated use radioPaddingYSmall
     */
    function get() {
      var controlHeight = parseInt(this.controlHeightSmall, 10) || 0;
      var lineHeight = parseInt(this.radioLineHeightSmall, 10) || 0;
      return (controlHeight - lineHeight) / 2 + "px";
    }
  }, {
    key: "radioPaddingYSmall",
    get: function get() {
      return this.radioPaddingY;
    }
  }, {
    key: "radioPaddingYMedium",
    get: function get() {
      var controlHeight = parseInt(this.controlHeightMedium, 10) || 0;
      var lineHeight = parseInt(this.radioLineHeightMedium, 10) || 0;
      return (controlHeight - lineHeight) / 2 + "px";
    }
  }, {
    key: "radioPaddingYLarge",
    get: function get() {
      var controlHeight = parseInt(this.controlHeightLarge, 10) || 0;
      var lineHeight = parseInt(this.radioLineHeightLarge, 10) || 0;
      return (controlHeight - lineHeight) / 2 + "px";
    }
  }, {
    key: "radioHoverBg",
    get: function get() {
      return this.checkboxHoverBg;
    }
  }, {
    key: "radioActiveBg",
    get: function get() {
      return this.checkboxActiveBg;
    }
  }, {
    key: "radioBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "radioBorderColor",
    get: function get() {
      return this.borderColorGrayLight;
    }
  }, {
    key: "radioBorder",
    get: function get() {
      return this.radioBorderWidth + " solid " + this.radioBorderColor;
    }
  }, {
    key: "radioBorderColorFocus",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "radioBorderColorWarning",
    get: function get() {
      return this.borderColorWarning;
    }
  }, {
    key: "radioBorderColorError",
    get: function get() {
      return this.borderColorError;
    }
  }, {
    key: "radioFocusShadow",
    get: function get() {
      return "inset 0 0 0 1px " + this.outlineColorFocus;
    }
  }, {
    key: "radioCheckedBgColor",
    get: function get() {
      return this.checkboxCheckedBg;
    }
  }, {
    key: "radioCheckedHoverBgColor",
    get: function get() {
      return ColorFunctions.darken(this.checkboxCheckedBg, '5%');
    }
  }, {
    key: "radioDisabledBg",
    get: function get() {
      return this.bgDisabled;
    }
  }, {
    key: "radioDisabledShadow",
    get: function get() {
      return "0 0 0 " + this.radioBorderWidth + " " + this.borderColorDisabled;
    }
  }, {
    key: "radioCheckedDisabledBulletBg",
    get: function get() {
      return this.gray;
    } //#endregion
    //#region RadioGroup

  }, {
    key: "tabFontSize",
    get: //#endregion
    //#region Tabs

    /**
     * @deprecated use tabFontSizeLarge
     */
    function get() {
      return this.fontSizeLarge;
    }
  }, {
    key: "tabFontSizeSmall",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "tabFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "tabFontSizeLarge",
    get: function get() {
      return this.tabFontSize;
    }
    /**
     * @deprecated use tabLineHeightLarge
     */

  }, {
    key: "tabLineHeight",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "tabLineHeightSmall",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "tabLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "tabLineHeightLarge",
    get: function get() {
      return this.tabLineHeight;
    }
    /**
     * @deprecated use tabPaddingXLarge
     */

  }, {
    key: "tabPaddingXLarge",
    get: function get() {
      return this.tabPaddingX;
    }
    /**
     * @deprecated use tabPaddingXLarge
     */

  }, {
    key: "tabsMarginX",
    get: function get() {
      return this.tabPaddingX;
    }
    /**
     * @deprecated use tabPaddingYLarge
     */

  }, {
    key: "tabPaddingY",
    get: function get() {
      var paddingY = parseInt(this.controlPaddingYLarge);
      var borderWidth = parseInt(this.controlBorderWidth);
      return paddingY + borderWidth + "px";
    }
  }, {
    key: "tabPaddingYSmall",
    get: function get() {
      var paddingY = parseInt(this.controlPaddingYSmall);
      var borderWidth = parseInt(this.controlBorderWidth);
      return paddingY + borderWidth + "px";
    }
  }, {
    key: "tabPaddingYMedium",
    get: function get() {
      var paddingY = parseInt(this.controlPaddingYMedium);
      var borderWidth = parseInt(this.controlBorderWidth);
      return paddingY + borderWidth + "px";
    }
  }, {
    key: "tabPaddingYLarge",
    get: function get() {
      return this.tabPaddingY;
    }
  }, {
    key: "tabOutlineWidth",
    get: function get() {
      return this.controlOutlineWidth;
    }
  }, {
    key: "tabTextColorDefault",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "tabColorFocus",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "tabColorError",
    get: function get() {
      return this.btnDangerBg;
    }
  }, {
    key: "tabColorWarning",
    get: function get() {
      return this.btnPayBg;
    }
  }, {
    key: "tabColorSuccess",
    get: function get() {
      return this.btnSuccessBg;
    }
  }, {
    key: "tabColorPrimary",
    get: function get() {
      return this.btnPrimaryBg;
    }
  }, {
    key: "tabColorHover",
    get: function get() {
      return this.borderColorFocusLight;
    }
  }, {
    key: "tabColorHoverError",
    get: function get() {
      return ColorFunctions.lighten(this.tabColorError, '25%');
    }
  }, {
    key: "tabColorHoverWarning",
    get: function get() {
      return ColorFunctions.lighten(this.tabColorWarning, '25%');
    }
  }, {
    key: "tabColorHoverSuccess",
    get: function get() {
      return ColorFunctions.lighten(this.tabColorSuccess, '25%');
    }
  }, {
    key: "tabColorHoverPrimary",
    get: function get() {
      return ColorFunctions.lighten(this.tabColorPrimary, '25%');
    }
  }, {
    key: "spinnerBgColor",
    get: //#endregion
    //#region Spinner
    function get() {
      return this.grayXLight;
    }
  }, {
    key: "spinnerColor",
    get: function get() {
      return this.red;
    }
  }, {
    key: "spinnerDimmedColor",
    get: function get() {
      return this.gray;
    }
  }, {
    key: "spinnerCaptionColor",
    get: function get() {
      return this.gray;
    }
  }, {
    key: "spinnerFontSizeSmall",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "spinnerFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "spinnerFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
  }, {
    key: "spinnerLineHeightSmall",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "spinnerLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "spinnerLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "switcherTextColor",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "switcherOutlineWidth",
    get: function get() {
      return this.btnOutlineWidth;
    }
  }, {
    key: "switcherCaptionFontSizeSmall",
    get: function get() {
      return this.btnFontSizeSmall;
    }
  }, {
    key: "switcherCaptionFontSizeMedium",
    get: function get() {
      return this.btnFontSizeMedium;
    }
  }, {
    key: "switcherCaptionFontSizeLarge",
    get: function get() {
      return this.btnFontSizeLarge;
    }
  }, {
    key: "switcherCaptionLineHeightSmall",
    get: function get() {
      return this.btnLineHeightSmall;
    }
  }, {
    key: "switcherCaptionLineHeightMedium",
    get: function get() {
      return this.btnLineHeightMedium;
    }
  }, {
    key: "switcherCaptionLineHeightLarge",
    get: function get() {
      return this.btnLineHeightLarge;
    }
  }, {
    key: "switcherCaptionGapSmall",
    get: function get() {
      return this.btnPaddingXSmall;
    }
  }, {
    key: "switcherCaptionGapMedium",
    get: function get() {
      return this.btnPaddingXMedium;
    }
  }, {
    key: "switcherCaptionGapLarge",
    get: function get() {
      return this.btnPaddingXLarge;
    }
  }, {
    key: "switcherButtonPaddingYSmall",
    get: function get() {
      return this.btnPaddingYSmall;
    }
  }, {
    key: "switcherButtonPaddingYMedium",
    get: function get() {
      return this.btnPaddingYMedium;
    }
  }, {
    key: "switcherButtonPaddingYLarge",
    get: function get() {
      return this.btnPaddingYLarge;
    }
  }, {
    key: "switcherButtonLineHeightSmall",
    get: function get() {
      return this.btnLineHeightSmall;
    }
  }, {
    key: "switcherButtonLineHeightMedium",
    get: function get() {
      return this.btnLineHeightMedium;
    }
  }, {
    key: "switcherButtonLineHeightLarge",
    get: function get() {
      return this.btnLineHeightLarge;
    }
  }, {
    key: "switcherButtonFontSizeSmall",
    get: function get() {
      return this.btnFontSizeSmall;
    }
  }, {
    key: "switcherButtonFontSizeMedium",
    get: function get() {
      return this.btnFontSizeMedium;
    }
  }, {
    key: "switcherButtonFontSizeLarge",
    get: function get() {
      return this.btnFontSizeLarge;
    }
  }, {
    key: "switcherButtonBorderRadiusSmall",
    get: function get() {
      return this.btnBorderRadiusSmall;
    }
  }, {
    key: "switcherButtonBorderRadiusMedium",
    get: function get() {
      return this.btnBorderRadiusMedium;
    }
  }, {
    key: "switcherButtonBorderRadiusLarge",
    get: function get() {
      return this.btnBorderRadiusLarge;
    }
  }, {
    key: "switcherButtonBorderWidth",
    get: function get() {
      return this.btnBorderWidth;
    }
  }, {
    key: "switcherButtonDisabledBorderColor",
    get: function get() {
      return this.switcherBtnDisabledBorderColor;
    }
  }, {
    key: "switcherButtonCheckedDisabledShadow",
    get: function get() {
      return this.btnCheckedDisabledShadow;
    } //#endregion
    //#region MobilePopup

  }, {
    key: "mobilePopupHeaderFontSize",
    get: function get() {
      return this.fontSizeMobile;
    }
  }, {
    key: "mobilePopupHeaderLineHeight",
    get: function get() {
      return this.lineHeightMobile;
    }
  }, {
    key: "globalLoaderColor",
    get: //#endregion
    //#region GlobalLoader
    function get() {
      return this.blueLight;
    }
  }, {
    key: "fileUploaderFontSize",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "fileUploaderPaddingXSmall",
    get: function get() {
      return this.inputPaddingXSmall;
    }
  }, {
    key: "fileUploaderPaddingXMedium",
    get: function get() {
      return this.inputPaddingXMedium;
    }
  }, {
    key: "fileUploaderPaddingXLarge",
    get: function get() {
      return this.inputPaddingXLarge;
    }
  }, {
    key: "fileUploaderFontSizeSmall",
    get: function get() {
      return this.fontSizeSmall;
    }
  }, {
    key: "fileUploaderFontSizeMedium",
    get: function get() {
      return this.fontSizeMedium;
    }
  }, {
    key: "fileUploaderFontSizeLarge",
    get: function get() {
      return this.fontSizeLarge;
    }
  }, {
    key: "fileUploaderLineHeight",
    get: function get() {
      return this.controlLineHeightSmall;
    }
  }, {
    key: "fileUploaderLineHeightSmall",
    get: function get() {
      return this.fileUploaderLineHeight;
    }
  }, {
    key: "fileUploaderLineHeightMedium",
    get: function get() {
      return this.controlLineHeightMedium;
    }
  }, {
    key: "fileUploaderLineHeightLarge",
    get: function get() {
      return this.controlLineHeightLarge;
    }
  }, {
    key: "fileUploaderPaddingYSmall",
    get: function get() {
      return this.fileUploaderPaddingY;
    }
  }, {
    key: "fileUploaderPaddingYMedium",
    get: function get() {
      return this.controlPaddingYMedium;
    }
  }, {
    key: "fileUploaderPaddingYLarge",
    get: function get() {
      return this.controlPaddingYLarge;
    }
  }, {
    key: "fileUploaderTextColorDefault",
    get: function get() {
      return this.textColorDefault;
    }
  }, {
    key: "fileUploaderPaddingY",
    get: function get() {
      return this.controlPaddingYSmall;
    }
  }, {
    key: "fileUploaderBorderWidth",
    get: function get() {
      return this.controlBorderWidth;
    }
  }, {
    key: "fileUploaderDisabledBorder",
    get: function get() {
      return this.fileUploaderBorderWidth + " solid " + this.fileUploaderDisabledBorderColor;
    }
  }, {
    key: "fileUploaderBorderColorFocus",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "fileUploaderLinkColor",
    get: function get() {
      return this.linkColor;
    }
  }, {
    key: "fileUploaderBorderColorError",
    get: function get() {
      return this.borderColorError;
    }
  }, {
    key: "fileUploaderBorderColorWarning",
    get: function get() {
      return this.borderColorWarning;
    }
  }, {
    key: "fileUploaderLinkHoverTextDecoration",
    get: function get() {
      return this.linkHoverTextDecoration;
    }
  }, {
    key: "fileUploaderDragOverBorderColor",
    get: function get() {
      return this.borderColorFocus;
    }
  }, {
    key: "closeBtnIconFocusShadow",
    get: function get() {
      return "inset 0 0 0 1px " + this.borderColorFocus + ", inset 0 0 0 2px " + this.outlineColorFocus;
    } //#endregion
    //#region InternalMenu
    //#endregion

  }]);

  return DefaultTheme;
}();
DefaultTheme.fontFamilyCompensationBaseline = '0px';
DefaultTheme.labGrotesqueBaselineCompensation = '1';
DefaultTheme.brandXLight = '#cae5f5';
DefaultTheme.brandLight = '#3094d0';
DefaultTheme.brand = '#2291ff';
DefaultTheme.brandDark = '#1363a0';
DefaultTheme.brandXDark = '#084f85';
DefaultTheme.white = '#fff';
DefaultTheme.grayXxLight = '#f2f2f2';
DefaultTheme.grayXLight = '#ebebeb';
DefaultTheme.grayLight = '#a0a0a0';
DefaultTheme.gray = '#858585';
DefaultTheme.grayDark = '#333';
DefaultTheme.black = '#000';
DefaultTheme.blueXxLight = '#cdedff';
DefaultTheme.blueLight = '#1f87ef';
DefaultTheme.blue = '#1874cf';
DefaultTheme.blueDark = '#1874cf';
DefaultTheme.blueXDark = '#044785';
DefaultTheme.greenXxLight = '#d7f8ae';
DefaultTheme.green = '#538a1b';
DefaultTheme.greenDark = '#477916';
DefaultTheme.redXxLight = '#ffddd6';
DefaultTheme.red = '#dd473b';
DefaultTheme.redDark = '#cb3d35';
DefaultTheme.yellowXxLight = '#ffeec2';
DefaultTheme.yellow = '#fcb73e';
DefaultTheme.yellowDark = '#ef8b17';
DefaultTheme.bgDefault = '#fff';
DefaultTheme.bgDisabled = '#f6f6f6';
DefaultTheme.errorMain = '#dd473b';
DefaultTheme.errorSecondary = '#ffd6d6';
DefaultTheme.errorText = '#cb3d35';
DefaultTheme.warningMain = '#fcb73e';
DefaultTheme.warningSecondary = '#fff0bc';
DefaultTheme.warningText = '#d97e00';
DefaultTheme.borderColorFocusLight = '#cdedff';
DefaultTheme.borderColorGrayDark = 'rgba(0, 0, 0, 0.28)';
DefaultTheme.borderColorGrayLight = 'rgba(0, 0, 0, 0.16)';
DefaultTheme.placeholderColor = '#adadad';
DefaultTheme.outlineColorFocus = '#fff';
DefaultTheme.placeholderColorLight = '#cdcdcd';
DefaultTheme.blinkColor = 'rgba(0, 136, 255, 0.2)';
DefaultTheme.controlBorderWidth = '1px';
DefaultTheme.controlOutlineWidth = '2px';
DefaultTheme.controlLineHeightSmall = '20px';
DefaultTheme.controlLineHeightMedium = '22px';
DefaultTheme.controlLineHeightLarge = '24px';
DefaultTheme.controlPaddingYSmall = '5px';
DefaultTheme.controlPaddingYMedium = '8px';
DefaultTheme.controlPaddingYLarge = '11px';
DefaultTheme.textColorDefault = '#222222';
DefaultTheme.textColorInvert = '#fff';
DefaultTheme.textColorDisabled = '#adadad';
DefaultTheme.textColorDisabledContrast = '#858585';
DefaultTheme.fontSizeSmall = '14px';
DefaultTheme.fontSizeMedium = '16px';
DefaultTheme.fontSizeLarge = '18px';
DefaultTheme.fontSizeMobile = '18px';
DefaultTheme.lineHeightMobile = '24px';
DefaultTheme.specificityLevel = '0';
DefaultTheme.fixedPanelShadow = '0 0 16px 1px rgba(0, 0, 0, 0.3)';
DefaultTheme.controlHeightSmall = '32px';
DefaultTheme.controlHeightMedium = '40px';
DefaultTheme.controlHeightLarge = '48px';
DefaultTheme.mobileMediaQuery = '(max-width: 576px) and (hover: none) and (pointer: coarse)';
DefaultTheme.transitionDuration = '100ms';
DefaultTheme.transitionTimingFunction = 'cubic-bezier(0.5, 1, 0.89, 1)';
DefaultTheme.linkColor = '#1874cf';
DefaultTheme.linkActiveColor = '#1260ae';
DefaultTheme.linkHoverTextDecoration = 'underline';
DefaultTheme.linkSuccessColor = '#477916';
DefaultTheme.linkSuccessHoverColor = '#477916';
DefaultTheme.linkSuccessActiveColor = '#325a0c';
DefaultTheme.linkDangerColor = '#cb3d35';
DefaultTheme.linkDangerHoverColor = '#cb3d35';
DefaultTheme.linkDangerActiveColor = '#a92a27';
DefaultTheme.linkIconMarginRight = '4px';
DefaultTheme.linkIconMarginLeft = '4px';
DefaultTheme.linkButtonLineHeight = '34px';
DefaultTheme.linkButtonPaddingX = '10px';
DefaultTheme.linkLineBorderBottomStyle = '';
DefaultTheme.linkLineBorderBottomWidth = '0px';
DefaultTheme.linkLineBorderBottomOpacity = '0.5';
DefaultTheme.linkLineBorderBottomColor = "color-mix(in srgb, currentColor " + parseFloat(DefaultTheme.linkLineBorderBottomOpacity) * 100 + "%, transparent)";
DefaultTheme.linkFocusOutlineColor = 'transparent';
DefaultTheme.linkFocusOutlineWidth = '0px';
DefaultTheme.linkFocusOutline = 'none';
DefaultTheme.tokenDisabledBg = 'rgba(0, 0, 0, 0.05)';
DefaultTheme.tokenMarginY = '3px';
DefaultTheme.tokenMarginX = '2px';
DefaultTheme.tokenMarginYMedium = '3px';
DefaultTheme.tokenMarginXMedium = '3px';
DefaultTheme.tokenMarginYLarge = '3px';
DefaultTheme.tokenMarginXLarge = '4px';
DefaultTheme.tokenPaddingY = '1px';
DefaultTheme.tokenPaddingX = '3px';
DefaultTheme.tokenPaddingYMedium = '2px';
DefaultTheme.tokenPaddingXMedium = '5px';
DefaultTheme.tokenPaddingYLarge = '3px';
DefaultTheme.tokenPaddingXLarge = '7px';
DefaultTheme.tokenMarginBeforeIcon = '4px';
DefaultTheme.tokenRemoveIconSize = '8px';
DefaultTheme.tokenRemoveIconPaddingY = '4px';
DefaultTheme.tokenRemoveIconPaddingX = '4px';
DefaultTheme.tokenRemoveIconGap = '4px';
DefaultTheme.tokenRemoveIconBoxSizing = 'content-box';
DefaultTheme.tokenBorderRadius = '1px';
DefaultTheme.tokenBorderWidth = '1px';
DefaultTheme.tokenBorderColorDisabled = 'transparent';
DefaultTheme.tokenOutlineWidth = '2px';
DefaultTheme.tokenLegacyTextShift = '0px';
DefaultTheme.tokenDefaultIdleBg = '';
DefaultTheme.tokenDefaultIdleColor = '';
DefaultTheme.tokenDefaultIdleBorderColor = '';
DefaultTheme.tokenDefaultIdleBgHover = '';
DefaultTheme.tokenDefaultIdleColorHover = '';
DefaultTheme.tokenDefaultIdleBorderColorHover = '';
DefaultTheme.tokenDefaultActiveBg = '';
DefaultTheme.tokenDefaultActiveColor = '';
DefaultTheme.tokenDefaultActiveBorderColor = '';
DefaultTheme.tokenInputBorderRadius = '0px';
DefaultTheme.tokenInputPaddingY = '1px';
DefaultTheme.tokenInputPaddingX = '2px';
DefaultTheme.tokenInputPaddingYMedium = '3px';
DefaultTheme.tokenInputPaddingXMedium = '3px';
DefaultTheme.tokenInputPaddingYLarge = '5px';
DefaultTheme.tokenInputPaddingXLarge = '4px';
DefaultTheme.tokenInputPopupOffset = '0px';
DefaultTheme.tokenInputPopupMarginSmall = '7px';
DefaultTheme.tokenInputPopupMarginMedium = '10px';
DefaultTheme.tokenInputPopupMarginLarge = '13px';
DefaultTheme.loaderBg = 'rgba(255, 255, 255, 0.8)';
DefaultTheme.loaderOpacity = '0.8';
DefaultTheme.loaderBorderRadius = '0px';
DefaultTheme.btnBackgroundClip = 'padding-box';
DefaultTheme.btnArrowBgImageActive = 'none';
DefaultTheme.btnArrowBgImageChecked = 'none';
DefaultTheme.btnLinkBorderRadius = '2px';
DefaultTheme.btnFocusShadowWidth = '2px';
DefaultTheme.btnBorderColorTransition = '';
DefaultTheme.btnDisabledBorderColor = 'rgba(0, 0, 0, 0.05)';
DefaultTheme.btnCheckedBg = '#7e7e7e';
DefaultTheme.btnCheckedDisabledBg = '#a0a0a0';
DefaultTheme.btnCheckedDisabledColor = 'rgba(255, 255, 255, 0.7)';
DefaultTheme.btnCheckedTextColor = '#fff';
DefaultTheme.btnCheckedShadow = 'none';
DefaultTheme.btnCheckedDisabledShadow = 'none';
DefaultTheme.btnBorderRadiusSmall = '1px';
DefaultTheme.btnBorderRadiusMedium = '1px';
DefaultTheme.btnBorderRadiusLarge = '1px';
DefaultTheme.btnInsetWidth = '1px';
DefaultTheme.btnPaddingXSmall = '15px';
DefaultTheme.btnPaddingXMedium = '15px';
DefaultTheme.btnPaddingXLarge = '19px';
DefaultTheme.btnIconGapSmall = '4px';
DefaultTheme.btnIconGapSmallRight = '4px';
DefaultTheme.btnIconGapMedium = '4px';
DefaultTheme.btnIconGapMediumRight = '4px';
DefaultTheme.btnIconGapLarge = '4px';
DefaultTheme.btnIconGapLargeRight = '4px';
DefaultTheme.btnIconSizeSmall = '16px';
DefaultTheme.btnIconSizeMedium = '18px';
DefaultTheme.btnIconSizeLarge = '20px';
DefaultTheme.btnDefaultBg = '#fff';
DefaultTheme.btnDefaultBgStart = 'none';
DefaultTheme.btnDefaultBgEnd = 'none';
DefaultTheme.btnDefaultHoverBg = '#f2f2f2';
DefaultTheme.btnDefaultHoverBgStart = 'none';
DefaultTheme.btnDefaultHoverBgEnd = 'none';
DefaultTheme.btnDefaultActiveBg = '#ebebeb';
DefaultTheme.btnDefaultHoverBorderColor = 'rgba(0, 0, 0, 0.16)';
DefaultTheme.btnDefaultHoverBorderBottomColor = '';
DefaultTheme.btnDefaultHoverTextColor = '';
DefaultTheme.btnDefaultActiveBorderColor = 'rgba(0, 0, 0, 0.16)';
DefaultTheme.btnDefaultActiveBorderTopColor = '';
DefaultTheme.btnDefaultBorderColor = 'rgba(0, 0, 0, 0.16)';
DefaultTheme.btnDefaultBorderBottomColor = '';
DefaultTheme.btnDefaultActiveShadow = 'none';
DefaultTheme.btnSuccessBg = '#538a1b';
DefaultTheme.btnSuccessHoverBg = '#477916';
DefaultTheme.btnSuccessHoverBorderColor = '#477916';
DefaultTheme.btnSuccessHoverBorderBottomColor = '';
DefaultTheme.btnSuccessHoverTextColor = '';
DefaultTheme.btnSuccessBorderColor = '#538a1b';
DefaultTheme.btnSuccessBorderBottomColor = '';
DefaultTheme.btnSuccessBgStart = 'none';
DefaultTheme.btnSuccessBgEnd = 'none';
DefaultTheme.btnSuccessTextColor = '#fff';
DefaultTheme.btnSuccessHoverBgStart = 'none';
DefaultTheme.btnSuccessHoverBgEnd = 'none';
DefaultTheme.btnSuccessActiveBg = '#3a6710';
DefaultTheme.btnSuccessActiveBorderColor = '#3a6710';
DefaultTheme.btnSuccessActiveBorderTopColor = '';
DefaultTheme.btnSuccessActiveShadow = 'none';
DefaultTheme.btnPrimaryBg = '#1c7edf';
DefaultTheme.btnPrimaryHoverBg = '#1874cf';
DefaultTheme.btnPrimaryHoverBorderColor = '#1874cf';
DefaultTheme.btnPrimaryHoverBorderBottomColor = '';
DefaultTheme.btnPrimaryHoverTextColor = '';
DefaultTheme.btnPrimaryBorderColor = '#1c7edf';
DefaultTheme.btnPrimaryBorderBottomColor = '';
DefaultTheme.btnPrimaryBgStart = 'none';
DefaultTheme.btnPrimaryBgEnd = 'none';
DefaultTheme.btnPrimaryTextColor = '#fff';
DefaultTheme.btnPrimaryHoverBgStart = 'none';
DefaultTheme.btnPrimaryHoverBgEnd = 'none';
DefaultTheme.btnPrimaryActiveBg = '#156abe';
DefaultTheme.btnPrimaryActiveBorderColor = '#156abe';
DefaultTheme.btnPrimaryActiveBorderTopColor = '';
DefaultTheme.btnPrimaryActiveShadow = 'none';
DefaultTheme.btnDangerBg = '#dd473b';
DefaultTheme.btnDangerHoverBg = '#cb3d35';
DefaultTheme.btnDangerHoverBorderColor = '#cb3d35';
DefaultTheme.btnDangerHoverBorderBottomColor = '';
DefaultTheme.btnDangerHoverTextColor = '';
DefaultTheme.btnDangerBorderColor = '#dd473b';
DefaultTheme.btnDangerBorderBottomColor = '';
DefaultTheme.btnDangerBgStart = 'none';
DefaultTheme.btnDangerBgEnd = 'none';
DefaultTheme.btnDangerTextColor = '#fff';
DefaultTheme.btnDangerHoverBgStart = 'none';
DefaultTheme.btnDangerHoverBgEnd = 'none';
DefaultTheme.btnDangerActiveBg = '#ba342e';
DefaultTheme.btnDangerActiveBorderColor = '#ba342e';
DefaultTheme.btnDangerActiveBorderTopColor = '';
DefaultTheme.btnDangerActiveShadow = 'none';
DefaultTheme.btnPayBg = '#fcb73e';
DefaultTheme.btnPayHoverBg = '#fda70c';
DefaultTheme.btnPayHoverBorderColor = '#fda70c';
DefaultTheme.btnPayHoverBorderBottomColor = '';
DefaultTheme.btnPayHoverTextColor = '';
DefaultTheme.btnPayBorderColor = '#fcb73e';
DefaultTheme.btnPayBorderBottomColor = '';
DefaultTheme.btnPayBgStart = 'none';
DefaultTheme.btnPayBgEnd = 'none';
DefaultTheme.btnPayHoverBgStart = 'none';
DefaultTheme.btnPayHoverBgEnd = 'none';
DefaultTheme.btnPayActiveBg = '#f69912';
DefaultTheme.btnPayActiveBorderColor = '#f69912';
DefaultTheme.btnPayActiveBorderTopColor = '';
DefaultTheme.btnPayActiveShadow = 'none';
DefaultTheme.btnMenuArrowColor = '#a6a6a6';
DefaultTheme.btnLinkLineBorderBottomStyle = '';
DefaultTheme.btnLinkLineBorderBottomWidth = '0px';
DefaultTheme.btnInsetColor = '#fff';
DefaultTheme.btnBacklessBg = 'transparent !important';
DefaultTheme.btnBacklessHoverBg = 'rgba(0, 0, 0, 0.04) !important';
DefaultTheme.btnBacklessActiveBg = 'rgba(0, 0, 0, 0.1) !important';
DefaultTheme.btnBacklessHoverTextColor = '';
DefaultTheme.btnTextBg = 'transparent';
DefaultTheme.btnTextHoverBg = 'rgba(0, 0, 0, 0.04)';
DefaultTheme.btnTextActiveBg = 'rgba(0, 0, 0, 0.1)';
DefaultTheme.btnTextHoverTextColor = '';
DefaultTheme.btnWithIconPaddingLeftSmall = '';
DefaultTheme.btnWithIconPaddingLeftMedium = '';
DefaultTheme.btnWithIconPaddingLeftLarge = '';
DefaultTheme.btnIconColor = '';
DefaultTheme.btnIconHoverColor = '';
DefaultTheme.btnIconDisabledColor = '';
DefaultTheme.selectPlaceholderColor = '#adadad';
DefaultTheme.selectPaddingXSmall = '7px';
DefaultTheme.selectIconGapSmall = '4px';
DefaultTheme.selectPaddingXMedium = '11px';
DefaultTheme.selectIconGapMedium = '8px';
DefaultTheme.selectPaddingXLarge = '15px';
DefaultTheme.selectIconGapLarge = '12px';
DefaultTheme.selectRootWidthMobile = 'auto';
DefaultTheme.mobileSelectMaxWidth = '100%';
DefaultTheme.selectBorderColorTransition = "box-shadow " + DefaultTheme.transitionDuration + " " + DefaultTheme.transitionTimingFunction + ";";
DefaultTheme.tooltipPaddingY = '16px';
DefaultTheme.tooltipPaddingX = '16px';
DefaultTheme.tooltipCloseBtnPadding = '8px';
DefaultTheme.tooltipCloseBtnSide = '8px';
DefaultTheme.tooltipCloseBtnColor = 'rgba(0, 0, 0, 0.32)';
DefaultTheme.tooltipCloseBtnHoverColor = 'rgba(0, 0, 0, 0.5)';
DefaultTheme.tooltipBg = '#fff';
DefaultTheme.tooltipPinOffset = '0px';
DefaultTheme.tooltipPinOffsetX = '16px';
DefaultTheme.tooltipPinOffsetY = '18px';
DefaultTheme.tooltipMargin = '10px';
DefaultTheme.kebabMargin = '4px';
DefaultTheme.kebabBackground = 'transparent';
DefaultTheme.kebabBackgroundHover = 'rgba(0, 0, 0, 0.09)';
DefaultTheme.kebabBorderRadius = '50%';
DefaultTheme.kebabBorder = '2px solid transparent';
DefaultTheme.kebabSizeSmall = '26px';
DefaultTheme.kebabSizeMedium = '26px';
DefaultTheme.kebabSizeLarge = '26px';
DefaultTheme.kebabIconSizeSmall = '14px';
DefaultTheme.kebabIconSizeMedium = '18px';
DefaultTheme.kebabIconSizeLarge = '20px';
DefaultTheme.kebabIconColor = '#757575';
DefaultTheme.modalWindowShadow = '0 5px 10px rgba(0, 0, 0, 0.2);';
DefaultTheme.modalBackBg = '#222';
DefaultTheme.modalBackOpacity = '0.6';
DefaultTheme.modalCloseButtonColor = 'rgba(0, 0, 0, 0.32)';
DefaultTheme.modalCloseButtonDisabledColor = '#8b8b8b';
DefaultTheme.modalCloseButtonHoverColor = 'rgba(0, 0, 0, 0.865)';
DefaultTheme.modalCloseButtonPadding = '36px';
DefaultTheme.modalCloseButtonLegacyShift = '0px';
DefaultTheme.modalCloseButtonBottomPadding = '20px';
DefaultTheme.modalCloseButtonClickArea = '10px';
DefaultTheme.modalCloseIconSize = '12px';
DefaultTheme.modalCloseLegacyGap = '0px';
DefaultTheme.modalCloseWrapperLegacyGap = '0px';
DefaultTheme.modalBorderRadius = '0px';
DefaultTheme.modalFixedHeaderBorder = 'none';
DefaultTheme.modalFixedFooterBorder = 'none';
DefaultTheme.modalFixedPanelShadow = 'none';
DefaultTheme.modalFooterBg = '#ebebeb';
DefaultTheme.modalAdaptiveThreshold = '425px';
DefaultTheme.modalPaddingTop = '24px';
DefaultTheme.modalPaddingLeft = '32px';
DefaultTheme.modalPaddingRight = '36px';
DefaultTheme.modalHeaderFontSize = '24px';
DefaultTheme.modalHeaderFontWeight = '400';
DefaultTheme.modalHeaderLineHeight = '32px';
DefaultTheme.modalHeaderPaddingBottom = '16px';
DefaultTheme.modalHeaderPaddingTop = '24px';
DefaultTheme.modalHeaderAdditionalPaddingBottom = '22px';
DefaultTheme.modalFixedHeaderMarginBottom = '10px';
DefaultTheme.modalFixedFooterPaddingTop = '20px';
DefaultTheme.modalFixedFooterMarginTop = '10px';
DefaultTheme.modalSeparatorBorderBottom = 'none';
DefaultTheme.modalBodyTextColor = 'inherit';
DefaultTheme.modalFooterTextColor = 'inherit';
DefaultTheme.modalBodyPaddingTop = '0';
DefaultTheme.modalBodyPaddingBottom = '24px';
DefaultTheme.modalBodyBorderRadius = '0px';
DefaultTheme.modalFooterPaddingTop = '0px';
DefaultTheme.modalFooterPaddingBottom = '32px';
DefaultTheme.modalPaddingBottom = '40px';
DefaultTheme.modalFooterPanelPaddingTop = '20px';
DefaultTheme.modalFooterPanelPaddingBottom = '20px';
DefaultTheme.mobileModalCloseButtonRightPadding = '16px';
DefaultTheme.mobileModalCloseButtonTopPadding = '12px';
DefaultTheme.mobileModalCloseButtonClickArea = '16px';
DefaultTheme.mobileModalCloseIconSize = '12px';
DefaultTheme.mobileModalHeaderFontSize = '24px';
DefaultTheme.mobileModalHeaderLineHeight = '32px';
DefaultTheme.mobileModalHeaderPadding = '16px';
DefaultTheme.mobileModalBodyPadding = '0 16px 16px 16px';
DefaultTheme.mobileModalBodyFontSize = '16px';
DefaultTheme.mobileModalFooterPadding = '16px';
DefaultTheme.mobileModalPaddingBottom = '16px';
DefaultTheme.mobileModalContainerHeight = '100%';
DefaultTheme.mobileModalContainerMarginTop = '0';
DefaultTheme.mobileModalContainerMarginRight = '0';
DefaultTheme.mobileModalContainerMarginBottom = '0';
DefaultTheme.mobileModalContainerMarginLeft = '0';
DefaultTheme.sidePageFooterPanelBg = '#ebebeb';
DefaultTheme.sidePageBackingBg = '#222';
DefaultTheme.sidePageBackingBgOpacity = '0.6';
DefaultTheme.sidePageCloseButtonColor = 'rgba(0, 0, 0, 0.374)';
DefaultTheme.sidePageCloseButtonHoverColor = 'rgba(0, 0, 0, 0.5)';
DefaultTheme.sidePageContainerShadow = '0 5px 10px rgba(0, 0, 0, 0.2)';
DefaultTheme.mobileSidePagePaddingLeft = '16px';
DefaultTheme.mobileSidePagePaddingRight = '16px';
DefaultTheme.mobileSidePagePaddingTop = '16px';
DefaultTheme.mobileSidePagePaddingBottom = '16px';
DefaultTheme.mobileSidePageFooterPadding = '16px';
DefaultTheme.sidePagePaddingLeft = '32px';
DefaultTheme.sidePagePaddingRight = '36px';
DefaultTheme.sidePagePaddingTop = '24px';
DefaultTheme.sidePagePaddingBottom = '40px';
DefaultTheme.sidePageFooterPaddingTop = '24px';
DefaultTheme.sidePageFooterPaddingBottom = '32px';
DefaultTheme.sidePageBodyTextColor = 'inherit';
DefaultTheme.sidePageFooterTextColor = 'inherit';
DefaultTheme.sidePageHeaderFontSize = '24px';
DefaultTheme.sidePageHeaderLineHeight = '32px';
DefaultTheme.sidePageHeaderPaddingBottom = '16px';
DefaultTheme.sidePageHeaderPaddingTop = '24px';
DefaultTheme.sidePageHeaderFixedFontSize = '18px';
DefaultTheme.sidePageHeaderFixedLineHeight = '28px';
DefaultTheme.sidePageHeaderFixedPaddingY = '10px';
DefaultTheme.sidePageHeaderStickyOffset = '5px';
DefaultTheme.sidePageCloseButtonPadding = '36px';
DefaultTheme.mobileSidePageCloseButtonPadding = '16px';
DefaultTheme.sidePageCloseButtonLegacyPaddingLeft = '36px';
DefaultTheme.sidePageFooterPanelPaddingTop = '20px';
DefaultTheme.sidePageFooterPanelPaddingBottom = '20px';
DefaultTheme.sidePageCloseIconSize = '12px';
DefaultTheme.sidePageCloseButtonClickArea = '10px';
DefaultTheme.mobileSidePageCloseButtonClickArea = '16px';
DefaultTheme.sidePageFixedPanelShadow = 'none';
DefaultTheme.mobileSidePageHeaderFontSize = '24px';
DefaultTheme.mobileSidePageHeaderLineHeight = '32px';
DefaultTheme.mobileSidePageHeaderPaddingBottom = '16px';
DefaultTheme.mobileSidePageHeaderPaddingTop = '16px';
DefaultTheme.sidePageHeaderFontWeight = '';
DefaultTheme.dateInputMaskColor = '#b8b8b8';
DefaultTheme.dateInputComponentSelectedBgColor = '#cdedff';
DefaultTheme.calendarCellHoverColor = 'white';
DefaultTheme.calendarCellActiveHoverColor = 'white';
DefaultTheme.calendarCellWeekendColor = '#cb3d35';
DefaultTheme.calendarCellTodayBorder = '1px solid rgba(0, 0, 0, 0.32)';
DefaultTheme.calendarCellBorderRadius = '9999px';
DefaultTheme.calendarCellSelectedBgColor = '#ebebeb';
DefaultTheme.calendarCellSelectedFontColor = 'inherit';
DefaultTheme.calendarCellSize = '32px';
DefaultTheme.calendarCellFontSize = '14px';
DefaultTheme.calendarMonthTitleBorderBottomColor = '#dfdede';
DefaultTheme.calendarPaddingX = '18px';
DefaultTheme.calendarMonthTitleLineHeight = '20px';
DefaultTheme.calendarMonthTitlePaddingTop = '12px';
DefaultTheme.calendarMonthTitlePaddingBottom = '8px';
DefaultTheme.calendarMonthTitleMarginX = '6px';
DefaultTheme.calendarMonthTitleMarginBottom = '6px';
DefaultTheme.calendarWrapperHeight = ' 330px';
DefaultTheme.calendarMonthMarginBottom = '6px';
DefaultTheme.calendarMaxMonthsToAppendOnScroll = '5';
DefaultTheme.calendarGridRowSpacing = '0px';
DefaultTheme.dateSelectLineHeight = '20px';
DefaultTheme.dateSelectFontSize = '14px';
DefaultTheme.dateSelectFontWeight = 'bold';
DefaultTheme.dateSelectMenuItemBgSelected = '#ececec';
DefaultTheme.datePickerMenuOffsetY = '2px';
DefaultTheme.pickerShadow = '0 4px 12px 0 rgba(0, 0, 0, 0.16)';
DefaultTheme.pickerTodayWrapperBorderTop = '1px solid #dfdede';
DefaultTheme.pickerTodayWrapperHoverBgColor = '#f5f5f5';
DefaultTheme.pickerTodayWrapperFontSize = '14px';
DefaultTheme.pickerTodayWrapperLineHeight = '20px';
DefaultTheme.pickerTodayWrapperPaddingTop = '6px';
DefaultTheme.pickerTodayWrapperPaddingBottom = '6px';
DefaultTheme.pickerBorderRadius = '';
DefaultTheme.mobileCalendarPaddingX = '16px';
DefaultTheme.mobileCalendarCellWidth = '40px';
DefaultTheme.mobileCalendarCellHeight = '40px';
DefaultTheme.mobileCalendarCellBorderRadius = '20px';
DefaultTheme.mobileCalendarCellFontSize = '16px';
DefaultTheme.mobileCalendarGridRowSpacing = '8px';
DefaultTheme.mobileDateSelectFontSize = '16px';
DefaultTheme.mobileDateSelectLineHeight = '20px';
DefaultTheme.mobileCalendarWrapperHeight = '304px';
DefaultTheme.pagingForwardIconMarginTop = '1px';
DefaultTheme.pagingPageLinkBoxSizing = 'content-box';
DefaultTheme.pagingPageLinkPaddingX = '0.625em';
DefaultTheme.pagingPageLinkPaddingY = '0.3125em';
DefaultTheme.pagingPageLinkLegacyPaddingY = '0px';
DefaultTheme.pagingPageLinkMinWidth = '0.75em';
DefaultTheme.pagingPageForwardLinkMarginTop = '0.35em';
DefaultTheme.pagingPageForwardLinkMarginLeft = '10px';
DefaultTheme.pagingPageForwardLinkPaddingRight = '1.375em';
DefaultTheme.pagingLineHeight = '1.375em';
DefaultTheme.pagingDotsColor = 'gray';
DefaultTheme.pagingDotsPadding = '0.375em 0.625em 0';
DefaultTheme.pagingPageLinkActiveBg = 'rgba(0, 0, 0, 0.09)';
DefaultTheme.pagingPageLinkDisabledActiveBg = 'rgba(0, 0, 0, 0.04)';
DefaultTheme.pagingPageLinkHoverBg = 'rgba(0, 0, 0, 0.05)';
DefaultTheme.pagingPageLinkBorderRadius = '9999px';
DefaultTheme.pagingPageLinkHintFontSize = '12px';
DefaultTheme.pagingPageLinkHintLineHeight = '16px';
DefaultTheme.pagingPageLinkHintMargin = '0 -20px';
DefaultTheme.pagingPageLinkMargin = '0px 1px';
DefaultTheme.hintMaxWidth = '200px';
DefaultTheme.hintPaddingY = '6px';
DefaultTheme.hintPaddingX = '8px';
DefaultTheme.hintTextAlign = 'center';
DefaultTheme.hintBgColor = 'rgba(51, 51, 51, 0.8)';
DefaultTheme.hintBorder = 'none';
DefaultTheme.hintBorderRadius = '2px';
DefaultTheme.hintPinOffset = '8px';
DefaultTheme.hintMargin = '8px';
DefaultTheme.toastPaddingY = '10px';
DefaultTheme.toastPaddingX = '16px';
DefaultTheme.toastBorderRadius = '2px';
DefaultTheme.toastBorder = 'none';
DefaultTheme.toastTop = '24px';
DefaultTheme.toastBg = 'rgba(51, 51, 51, 0.8)';
DefaultTheme.toastColor = 'white';
DefaultTheme.toastLinkColor = '#8fcdff';
DefaultTheme.toastLinkTextDecorationHover = 'underline';
DefaultTheme.toastLinkBgHover = '';
DefaultTheme.toastLinkBgActive = '';
DefaultTheme.toastClosePadding = '16px';
DefaultTheme.toastCloseColor = 'rgba(255, 255, 255, 0.6)';
DefaultTheme.toastCloseHoverColor = 'white';
DefaultTheme.toastCloseSize = '8px';
DefaultTheme.dropdownMenuSelectedBg = '#f1f1f1';
DefaultTheme.dropdownMenuBorderColorTransition = '';
DefaultTheme.dropdownMenuMenuBoxSizing = 'content-box';
DefaultTheme.dropdownButtonBorderRadiusSmall = '1px';
DefaultTheme.dropdownButtonBorderRadiusMedium = '1px';
DefaultTheme.dropdownButtonBorderRadiusLarge = '1px';
DefaultTheme.menuBorder = 'none';
DefaultTheme.menuShadow = '0 4px 12px rgba(0, 0, 0, 0.16)';
DefaultTheme.menuPaddingY = '0px';
DefaultTheme.menuLegacyPaddingY = '5px';
DefaultTheme.menuScrollContainerContentWrapperPaddingY = '4px';
DefaultTheme.mobileMenuPaddingY = '0px';
DefaultTheme.mobileMenuScrollContainerContentWrapperPaddingY = '0px';
DefaultTheme.menuPaddingX = '0px';
DefaultTheme.mobileMenuPaddingX = '8px';
DefaultTheme.menuOffsetY = '0px';
DefaultTheme.menuBoxSizing = 'content-box';
DefaultTheme.menuItemIconWidth = '16px';
DefaultTheme.menuItemIconWidthMedium = '20px';
DefaultTheme.menuItemIconWidthLarge = '24px';
DefaultTheme.menuItemIconGap = '4px';
DefaultTheme.menuItemIconLegacyMargin = '0px';
DefaultTheme.menuItemIconLegacyShift = '0px';
DefaultTheme.menuItemPaddingX = '8px';
DefaultTheme.menuItemPaddingY = '6px';
DefaultTheme.menuItemPaddingXMedium = '12px';
DefaultTheme.menuItemPaddingYMedium = '9px';
DefaultTheme.menuItemPaddingXLarge = '16px';
DefaultTheme.menuItemPaddingYLarge = '12px';
DefaultTheme.menuItemBorderRadius = '0px';
DefaultTheme.menuItemLegacyPaddingX = '0px';
DefaultTheme.menuItemLegacyPaddingY = '0px';
DefaultTheme.menuItemCommentColor = '#adadad';
DefaultTheme.menuItemCommentOpacity = '';
DefaultTheme.menuItemCommentColorHover = '#fff';
DefaultTheme.menuItemDisplay = 'block';
DefaultTheme.menuItemPaddingMobile = '12px 16px';
DefaultTheme.menuItemDisabledBg = 'transparent';
DefaultTheme.menuItemGap = '0px';
DefaultTheme.menuHeaderColor = '#757575';
DefaultTheme.menuHeaderLineHeight = '16px';
DefaultTheme.menuHeaderLineHeightMedium = '20px';
DefaultTheme.menuHeaderLineHeightLarge = '22px';
DefaultTheme.menuHeaderFontSize = '12px';
DefaultTheme.menuHeaderFontSizeMedium = '14px';
DefaultTheme.menuHeaderFontSizeLarge = '16px';
DefaultTheme.menuHeaderPaddingX = '8px';
DefaultTheme.menuHeaderPaddingTop = '12px';
DefaultTheme.menuHeaderPaddingBottom = '4px';
DefaultTheme.menuHeaderPaddingXMedium = '12px';
DefaultTheme.menuHeaderPaddingTopMedium = '14px';
DefaultTheme.menuHeaderPaddingBottomMedium = '6px';
DefaultTheme.menuHeaderPaddingXLarge = '16px';
DefaultTheme.menuHeaderPaddingTopLarge = '18px';
DefaultTheme.menuHeaderPaddingBottomLarge = '8px';
DefaultTheme.menuHeaderTotalCountPaddingTopSmall = '4px';
DefaultTheme.menuHeaderTotalCountPaddingTopMedium = '6px';
DefaultTheme.menuHeaderTotalCountPaddingTopLarge = '8px';
DefaultTheme.menuHeaderTotalCountPaddingBottomSmall = '12px';
DefaultTheme.menuHeaderTotalCountPaddingBottomMedium = '14px';
DefaultTheme.menuHeaderTotalCountPaddingBottomLarge = '18px';
DefaultTheme.menuHeaderLegacyPaddingRight = '0px';
DefaultTheme.menuFooterLegacyPaddingRight = '0px';
DefaultTheme.menuSeparatorBorderColor = '#ebebeb';
DefaultTheme.menuSeparatorMarginY = '2px';
DefaultTheme.menuSeparatorMarginX = '0px';
DefaultTheme.menuSeparatorBorderWidth = '1px';
DefaultTheme.mobileMenuSeparatorMarginY = '4px';
DefaultTheme.mobileMenuSeparatorMarginX = '24px';
DefaultTheme.toggleHandleActiveWidthIncrement = '4px';
DefaultTheme.toggleHeight = '20px';
DefaultTheme.toggleWidth = '32px';
DefaultTheme.toggleHeightMedium = '22px';
DefaultTheme.toggleWidthMedium = '34px';
DefaultTheme.toggleHeightLarge = '24px';
DefaultTheme.toggleWidthLarge = '36px';
DefaultTheme.toggleBg = '#fff';
DefaultTheme.toggleCheckedBg = '#fff';
DefaultTheme.toggleDisabledHandleBg = '#fff';
DefaultTheme.toggleBaseBg = '#fff';
DefaultTheme.toggleBgDisabledChecked = '#dadada';
DefaultTheme.toggleBgHover = '#f3f3f2';
DefaultTheme.toggleCheckedBgHover = '#f3f3f2';
DefaultTheme.toggleBgChecked = '#1874cf';
DefaultTheme.toggleBorderColor = 'rgba(0, 0, 0, 0.16)';
DefaultTheme.toggleBgFocus = 'linear-gradient(-180deg, #f1f1f1, #dedede)';
DefaultTheme.toggleBgActive = '#e5e5e5';
DefaultTheme.toggleCaptionGap = '8px';
DefaultTheme.toggleButtonOffsetY = '0px';
DefaultTheme.toggleContainerBg = '';
DefaultTheme.toggleContainerBgCheckedHover = '';
DefaultTheme.toggleContainerBoxShadow = '';
DefaultTheme.toggleContainerBoxShadowHover = '';
DefaultTheme.toggleContainerBoxShadowChecked = '';
DefaultTheme.toggleContainerBoxShadowCheckedHover = '';
DefaultTheme.toggleHandleBgHover = '';
DefaultTheme.toggleHandleBgChecked = '';
DefaultTheme.toggleHandleBgCheckedHover = '';
DefaultTheme.toggleHandleBoxShadow = '';
DefaultTheme.toggleHandleBoxShadowHover = '';
DefaultTheme.toggleHandleBoxShadowChecked = '';
DefaultTheme.toggleHandleBoxShadowCheckedHover = '';
DefaultTheme.toggleContainerBgDisabled = '';
DefaultTheme.toggleHandleBgDisabled = '';
DefaultTheme.toggleContainerBoxShadowDisabled = '';
DefaultTheme.toggleHandleBoxShadowDisabled = '';
DefaultTheme.toggleContainerBgDisabledChecked = '';
DefaultTheme.toggleHandleBgDisabledChecked = '';
DefaultTheme.toggleContainerBoxShadowDisabledChecked = '';
DefaultTheme.toggleHandleBoxShadowDisabledChecked = '';
DefaultTheme.popupBorder = 'none';
DefaultTheme.popupBorderRadius = '2px';
DefaultTheme.popupBorderColor = 'transparent';
DefaultTheme.popupDropShadow = 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.16))';
DefaultTheme.popupBoxShadow = '0 4px 12px 0 rgba(0, 0, 0, 0.16)';
DefaultTheme.popupPinOffset = '0px';
DefaultTheme.popupPinOffsetX = '16px';
DefaultTheme.popupPinOffsetY = '16px';
DefaultTheme.popupMargin = '10px';
DefaultTheme.popupPinSize = '8px';
DefaultTheme.popupMenuMenuOffsetY = '0px';
DefaultTheme.inputShadow = 'none';
DefaultTheme.inputBg = 'white';
DefaultTheme.inputIconColor = '#a9a9a9';
DefaultTheme.inputColor = 'inherit';
DefaultTheme.inputWidth = '200px';
DefaultTheme.inputPaddingXSmall = '7px';
DefaultTheme.inputPaddingXMedium = '11px';
DefaultTheme.inputPaddingXLarge = '15px';
DefaultTheme.inputIconGapSmall = '4px';
DefaultTheme.inputIconGapMedium = '8px';
DefaultTheme.inputIconGapLarge = '12px';
DefaultTheme.inputIconSizeSmall = '16px';
DefaultTheme.inputIconSizeMedium = '18px';
DefaultTheme.inputIconSizeLarge = '20px';
DefaultTheme.inputBackgroundClip = 'padding-box';
DefaultTheme.inputBorderRadiusSmall = '0px';
DefaultTheme.inputBorderRadiusMedium = '0px';
DefaultTheme.inputBorderRadiusLarge = '0px';
DefaultTheme.inputDisabledBackgroundClip = '';
DefaultTheme.inputBorderTopColor = 'rgba(0, 0, 0, 0.15)';
DefaultTheme.inputColorScheme = 'light';
DefaultTheme.checkboxBoxSize = '16px';
DefaultTheme.checkboxBoxSizeSmall = '16px';
DefaultTheme.checkboxBoxSizeMedium = '20px';
DefaultTheme.checkboxBoxSizeLarge = '24px';
DefaultTheme.checkboxCaptionGap = '8px';
DefaultTheme.checkboxBoxOffsetY = '1px';
DefaultTheme.checkboxBgStart = '#fdfdfd';
DefaultTheme.checkboxBgEnd = '#ededed';
DefaultTheme.checkboxBorder = 'none';
DefaultTheme.checkboxCheckedColor = '#fff';
DefaultTheme.checkboxBorderRadius = '1px';
DefaultTheme.checkboxBg = '#fff';
DefaultTheme.textareaBg = '#fff';
DefaultTheme.textareaShadow = 'none';
DefaultTheme.textareaBackgroundClip = 'border-box';
DefaultTheme.textareaBorderRadius = '0px';
DefaultTheme.textareaWidth = '250px';
DefaultTheme.textareaPaddingX = '7px';
DefaultTheme.textareaPaddingXMedium = '11px';
DefaultTheme.textareaPaddingXLarge = '15px';
DefaultTheme.textareaBorderTopColor = 'rgba(0, 0, 0, 0.16)';
DefaultTheme.textareaDisabledBg = 'rgba(0, 0, 0, 0.05)';
DefaultTheme.textareaDisabledBorderColor = 'transparent';
DefaultTheme.radioBulletSize = '8px';
DefaultTheme.radioBulletSizeMedium = '10px';
DefaultTheme.radioBulletSizeLarge = '12px';
DefaultTheme.radioSize = '16px';
DefaultTheme.radioSizeMedium = '20px';
DefaultTheme.radioSizeLarge = '24px';
DefaultTheme.radioCaptionGap = '8px';
DefaultTheme.radioVerticalAlign = 'top';
DefaultTheme.radioBgImage = 'none';
DefaultTheme.radioBgColor = '#fff';
DefaultTheme.radioBoxShadow = 'none';
DefaultTheme.radioHoverShadow = 'none';
DefaultTheme.radioActiveShadow = 'none';
DefaultTheme.radioCheckedBorderColor = 'transparent';
DefaultTheme.radioCheckedBulletColor = '#fff';
DefaultTheme.radioCaptionDisplay = 'inline-flex';
DefaultTheme.radioBorderWidthCompensation = '0px';
DefaultTheme.radioCircleOffsetY = '1px';
DefaultTheme.radioGroupLegacyItemGap = '0px';
DefaultTheme.tabPaddingX = '12px';
DefaultTheme.tabPaddingXSmall = '8px';
DefaultTheme.tabPaddingXMedium = '10px';
DefaultTheme.tabBorderWidth = '2px';
DefaultTheme.tabIndicatorBorderRadius = '0px';
DefaultTheme.spinnerCaptionGapSmall = '6px';
DefaultTheme.spinnerCaptionGapMedium = '-4px';
DefaultTheme.spinnerCaptionGapLarge = '-3px';
DefaultTheme.spinnerCaptionMarginSmall = '0 0 0 6px';
DefaultTheme.spinnerCaptionMarginMedium = '0 0 0 6px';
DefaultTheme.spinnerCaptionMarginLarge = '0 0 0 6px';
DefaultTheme.switcherBorderRadius = '2px';
DefaultTheme.switcherButtonPaddingXSmall = '7px';
DefaultTheme.switcherButtonPaddingXMedium = '11px';
DefaultTheme.switcherButtonPaddingXLarge = '15px';
DefaultTheme.switcherBtnDisabledBorderColor = 'rgba(0, 0, 0, 0.16)';
DefaultTheme.mobilePopupTopPadding = '80px';
DefaultTheme.mobilePopupContainerBottomPadding = '8px';
DefaultTheme.mobilePopupHeaderPadding = '16px 16px 8px 16px';
DefaultTheme.mobilePopupFooterPadding = '16px 16px 16px 16px';
DefaultTheme.mobilePopupContainerBorderRadius = '16px';
DefaultTheme.mobilePopupHeaderFontWeight = '500';
DefaultTheme.mobilePopupHeaderChildPadding = '12px';
DefaultTheme.mobilePopupOuterIndentY = '24px';
DefaultTheme.scrollContainerScrollBarSize = '4px';
DefaultTheme.scrollContainerScrollBarHoverSize = '10px';
DefaultTheme.scrollContainerScrollBarColor = 'rgba(183, 183, 183, 0.7)';
DefaultTheme.scrollContainerScrollBarInvertColor = 'rgba(255, 255, 255, 0.5)';
DefaultTheme.scrollContainerScrollBarOffsetY = '4px';
DefaultTheme.dropdownMenuScrollContainerScrollBarOffsetY = '0px';
DefaultTheme.passwordInputVisibilityIconColor = '#000';
DefaultTheme.passwordInputVisibilityIconOpacity = '0.6';
DefaultTheme.passwordInputVisibilityIconHoverColor = '#000';
DefaultTheme.passwordInputVisibilityIconHoverOpacity = '1';
DefaultTheme.globalLoaderHeight = '4px';
DefaultTheme.globalLoaderWidth = '100%';
DefaultTheme.globalLoaderPosition = 'fixed';
DefaultTheme.globalLoaderTop = '0px';
DefaultTheme.globalLoaderLeft = '0px';
DefaultTheme.globalLoaderBottom = 'auto';
DefaultTheme.globalLoaderRight = 'auto';
DefaultTheme.globalLoaderBackgroundColor = 'transparent';
DefaultTheme.globalLoaderTransitionToSpinnerDuration = '500';
DefaultTheme.globalLoaderSpinnerAnimationDuration = '2000';
DefaultTheme.globalLoaderSlowAnimationDuration = '20000';
DefaultTheme.globalLoaderTransitionFromSpinnerDuration = '200';
DefaultTheme.fileUploaderWidth = '362px';
DefaultTheme.fileUploaderBg = '#fff';
DefaultTheme.fileUploaderUploadButtonBg = '';
DefaultTheme.fileUploaderPaddingX = '7px';
DefaultTheme.fileUploaderBorderRadius = '2px';
DefaultTheme.fileUploaderBorderColor = 'rgba(0, 0, 0, 0.37)';
DefaultTheme.fileUploaderBorderStyle = 'dashed';
DefaultTheme.fileUploaderAfterLinkColor = '';
DefaultTheme.fileUploaderIconSize = '14px';
DefaultTheme.fileUploaderIconColor = '#808080';
DefaultTheme.fileUploaderIconHoverColor = '#333';
DefaultTheme.fileUploaderDisabledBg = '#f2f2f2';
DefaultTheme.fileUploaderDisabledBgClip = '';
DefaultTheme.fileUploaderDisabledBorderColor = '#f2f2f2';
DefaultTheme.fileUploaderDisabledTextColor = '#808080';
DefaultTheme.fileUploaderDisabledLinkColor = '#808080';
DefaultTheme.fileUploaderDisabledIconColor = '#A0A0A0';
DefaultTheme.fileUploaderHoveredBg = 'none';
DefaultTheme.fileUploaderHoveredBorderColor = '';
DefaultTheme.fileUploaderIconGapSmall = '4px';
DefaultTheme.fileUploaderIconGapMedium = '6px';
DefaultTheme.fileUploaderIconGapLarge = '8px';
DefaultTheme.fileUploaderDragOverShadow = '0px 0px 0px 3px #2da4f9, 0px 0px 0px 8px rgba(45, 164, 249, 0.35)';
DefaultTheme.closeBtnIconColor = 'rgba(0, 0, 0, 0.32)';
DefaultTheme.closeBtnIconDisabledColor = '#8b8b8b';
DefaultTheme.closeBtnIconHoverColor = 'rgba(0, 0, 0, 0.865)';
DefaultTheme.closeBtnIconBorderRadius = '4px';
DefaultTheme.internalMenuPaddingY = '5px';
DefaultTheme.autocompleteMenuOffsetY = '2px';
DefaultTheme.comboboxMenuOffsetY = '2px';
DefaultTheme.miniModalHeaderPaddingBottom = '0';
DefaultTheme.miniModalBodyPaddingTop = '16px';
DefaultTheme.miniModalBodyPaddingBottom = '0';
DefaultTheme.miniModalHeaderPaddingTop = '32px';
DefaultTheme.miniModalActionGap = '8px';
DefaultTheme.miniModalCancelIndent = '8px';
DefaultTheme.miniModalFooterPaddingTop = '24px';
DefaultTheme.miniModalFooterPaddingBottom = '32px';
DefaultTheme.miniModalTitleMarginTop = '16px';
DefaultTheme.miniModalHeightMobile = 'auto';
DefaultTheme.miniModalMarginTopMobile = '80px';
DefaultTheme.miniModalMarginLeftMobile = '24px';
DefaultTheme.miniModalMarginRightMobile = '24px';
DefaultTheme.miniModalFooterPaddingMobile = '24px 16px 16px';
DefaultTheme.miniModalHeaderPaddingMobile = '32px 16px 0';
DefaultTheme.miniModalBodyPaddingMobile = '16px 16px 0';
DefaultTheme.validationsTextColorError = '#cb3d35';
DefaultTheme.validationsTextColorWarning = '#ef8b17';
export var DefaultThemeInternal = exposeGetters(DefaultTheme);